<template>
  <div class="home">
      <LoaderComponent v-show="loaded" :loaderText="loaderText" />
      <HeaderView />
      <section class="new-product-page-main-sec order-page-main-sec agency-design-grid-right">
          <div class="desktop-respovsive-main-sec">
              <div class="place-order-top-sec">
                  <div class="order-list-tabs">
                      <h2 class="text-heading">Place Your Order
                        <span class="step-indicator">Step 1/2</span>
                      </h2>
                      <div class="draft-autosave-text" :class="{ 'order-title-error': validation.order_title }">
                          <input
                            type="text"
                            class="form-control"
                            :class="{ 'has-error border-danger': validation.order_title }"
                            id="formGroupExampleInput"
                            maxlength="100"
                            placeholder="Add any title here, that will help you track this order later"
                            v-model="form.order_title"
                          />
                      </div>
                  </div>
              </div>

              <div class="editor-dashboard-sec-2 new-product-form-wrapper">
                  <div
                      v-for="(link, linkIndex) in links.slice(0, maxRenderedLinks)"
                      :key="link.id"
                      class="link-section-box"
                  >
                      <div class="link-section-header">
                          <div class="link-title-box">
                              <h3>Link {{ linkIndex + 1 }}</h3>
                              <span class="traffic-badge">{{ link.url || "" }}</span>
                          </div>
                          <div class="link-price-actions">
                              <span class="link-price">Link Price: <span class="link-price-value">${{ numberFormat(link.total || 0) }}</span></span>
                              <button class="icon-btn" type="button" @click="copyLink(linkIndex)">
                                  <i class="fas fa-copy"></i>
                              </button>
                              <button v-if="links.length > 1" class="icon-btn" type="button" @click="removeLink(linkIndex)">
                                  <i class="fas fa-trash"></i>
                              </button>
                          </div>
                      </div>

                      <div class="link-form-content">
                          <b-row>
                              <b-col md="1">
                                  <div class="form-group">
                                      <label>
                                          Metric
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.metric"></i>
                                      </label>
                                      <div class="metric-toggle-box">
                                          <span 
                                              class="metric-option" 
                                              :class="{ active: link.metric === 'DA', 'metric-option-disabled': isLinkLockedByCustomPrice(link) }"
                                              @click="setMetric(linkIndex, 'DA')"
                                          >DA</span>
                                          <span 
                                              class="metric-option" 
                                              :class="{ active: link.metric === 'DR', 'metric-option-disabled': isLinkLockedByCustomPrice(link) }"
                                              @click="setMetric(linkIndex, 'DR')"
                                          >DR</span>
                                      </div>
                                  </div>
                              </b-col>
                              <b-col md="2">
                                  <div class="form-group">
                                      <label v-if="link.metric === 'DA' || link.metric === 'DR'">
                                          {{ link.metric }} Value
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.metricValue"></i>
                                      </label>
                                      <b-form-select
                                          v-model="link.product"
                                          class="form-control"
                                          :class="{ 'locked-field': isLinkLockedByCustomPrice(link), 'has-error border-danger': validation.links[linkIndex]?.product }"
                                          v-if="link.metric === 'DA' || link.metric === 'DR'"
                                          @input="onProductChange(linkIndex, $event)"
                                          :disabled="isLinkLockedByCustomPrice(link)"
                                      >
                                          <option :value="null" disabled hidden>Select {{ link.metric }}</option>
                                          <option
                                              v-for="pd in metricProductsFor(link.metric)"
                                              :key="pd.id"
                                              :value="pd"
                                          >
                                              {{ pd.name }}
                                          </option>
                                      </b-form-select>
                                  </div>
                              </b-col>
                              <b-col md="2">
                                  <div class="form-group">
                                      <label>
                                          Industry
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.industry"></i>
                                      </label>
                                      <b-form-select
                                          v-model="link.primary_category"
                                          class="form-control"
                                          :class="{ 'locked-field': isLinkLockedByCustomPrice(link), 'has-error border-danger': validation.links[linkIndex]?.primary_category }"
                                          :disabled="!link.product || isLinkLockedByCustomPrice(link)"
                                          @input="onCategoryChange(linkIndex, $event)"
                                      >
                                          <option :value="null" disabled hidden>Select Industry</option>
                                          <option
                                              v-for="cat in (categories[linkIndex] || [])"
                                              :key="cat.id"
                                              :value="cat"
                                          >
                                              {{ categoryPriceLabel(link, cat) }}
                                          </option>
                                      </b-form-select>
                                  </div>
                              </b-col>
                              <b-col md="2">
                                  <div class="form-group">
                                      <label>
                                          Secondary Category
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.secondaryCategory"></i>
                                      </label>
                                      <b-form-input 
                                          v-model="link.secondry_category" 
                                          type="text" 
                                          placeholder="Enter Secondary Category"
                                          class="form-control"
                                          :class="{ 'has-error border-danger': validation.links[linkIndex]?.secondry_category }"
                                      ></b-form-input>
                                  </div>
                              </b-col>
                              <b-col md="2">
                                  <div class="form-group">
                                      <label>
                                          Anchor Text
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.anchorText"></i>
                                      </label>
                                      <b-form-input 
                                          v-model="link.text" 
                                          type="text" 
                                          placeholder="Enter Anchor Text"
                                          class="form-control"
                                          :class="{ 'has-error border-danger': validation.links[linkIndex]?.text }"
                                      ></b-form-input>
                                  </div>
                              </b-col>
                             
                              <b-col md="3">
                                  <div class="form-group">
                                      <label>
                                          Destination URL
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.destinationUrl"></i>
                                      </label>
                                      <b-form-input 
                                          v-model="link.url" 
                                          type="url" 
                                          class="form-control"
                                          placeholder="https://"
                                          :class="{ 'has-error border-danger': validation.links[linkIndex]?.url }"
                                      ></b-form-input>
                                  </div>
                              </b-col>
                          </b-row>
                      </div>
                            <!-- Hyper Targeting Section -->
                  <div class="hyper-targeting-box">
                      <div class="hyper-targeting-header" @click="toggleHyperTargeting(linkIndex)">
                          <div class="hyper-targeting-title">
                              <h3>Hyper Targeting</h3>
                              <span class="optional-badge">Add-Ons Optional</span>
                          </div>
                          <i 
                              class="fas" 
                              :class="link.hyperTargetingExpanded ? 'fa-chevron-up' : 'fa-chevron-down'"
                          ></i>
                      </div>

                      <div class="hyper-targeting-content" v-if="link.hyperTargetingExpanded">
                          <b-row>
                              <b-col md="4">
                                  <div class="form-group">
                                      <label>
                                          Minimum Organic Traffic 
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.traffic"></i>
                                      </label>
                                      <div
                                          class="select-with-price addon-conflict-tip-wrap"
                                          :class="{ 'addon-select-disabled': isTrafficSelectDisabled(link) }"
                                      >
                                          <b-form-select
                                              v-model="link.traffic_selected_addon"
                                              class="form-control"
                                              :class="{ 'addon-select-control-disabled': isTrafficSelectDisabled(link) }"
                                              :disabled="isTrafficSelectDisabled(link)"
                                              @input="onTrafficSelect(linkIndex, $event)"
                                          >
                                              <option value="null" :title="trafficDefaultOptionText(link)">
                                                  {{ trafficDefaultOptionText(link) }}
                                              </option>
                                              <template v-if="trafficAddonProduct && (addon_da_options[linkIndex] || []).length > 0">
                                                  <option
                                                      v-for="opt in trafficAddonOptions(linkIndex)"
                                                      :key="opt.id"
                                                      :value="JSON.stringify(opt)"
                                                  >
                                                      {{ opt.name }}
                                                      (${{ numberFormat(opt.cost || 0) }})
                                                  </option>
                                              </template>
                                          </b-form-select>
                                          <span class="price-tag">${{ numberFormat(selectedTrafficCost(linkIndex)) }}</span>
                                          <span
                                              v-if="trafficConflictTitle(link)"
                                              class="addon-conflict-tip"
                                          >{{ trafficConflictTitle(link) }}</span>
                                      </div>
                                  </div>
                              </b-col>
                              <b-col md="4">
                                  <div class="form-group">
                                      <label>
                                          Country
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.country"></i>
                                      </label>
                                      <div
                                          class="select-with-price"
                                          :class="{ 'addon-select-disabled': isCountrySelectDisabled(link) }"
                                      >
                                          <b-form-select
                                              v-model="link.country_selected_addon"
                                              class="form-control"
                                              :class="{ 'addon-select-control-disabled': isCountrySelectDisabled(link) }"
                                              :disabled="isCountrySelectDisabled(link)"
                                              @input="onCountrySelect(linkIndex, $event)"
                                          >
                                              <option value="null">USA</option>
                                              <template v-if="countryAddonOptions(linkIndex).length > 0">
                                                  <option
                                                      v-for="opt in countryAddonOptions(linkIndex)"
                                                      :key="opt.id"
                                                      :value="JSON.stringify(opt)"
                                                  >
                                                      {{ opt.name }}
                                                      (${{ numberFormat(opt.cost || 0) }})
                                                  </option>
                                              </template>
                                          </b-form-select>
                                          <span class="price-tag">${{ numberFormat(selectedCountryCost(linkIndex)) }}</span>
                                      </div>
                                  </div>
                              </b-col>
                              <!-- <b-col md="3">
                                  <div class="form-group">
                                      <label>
                                          Placement Type
                                          <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.placementType"></i>
                                      </label>
                                      <div class="select-with-price">
                                          <b-form-select v-model="link.placementType" class="form-control">
                                              <option value="guest-post">Guest Post (Default)</option>
                                              <option value="article">Article</option>
                                              <option value="review">Review</option>
                                          </b-form-select>
                                          <span class="price-tag">$0</span>
                                      </div>
                                  </div>
                              </b-col> -->
                          </b-row>
                          <div class="targeting-options-section">
                           
                              <div class="targeting-option-group">
                                  <label class="section-label">
                                    Stable Traffic Graph
                                      <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.trafficStability"></i>
                                  </label>
                                  <div class="checkbox-group">
                                      <div
                                          class="form-group checkbox"
                                          :class="{ 'addon-disabled': isAddonOptionDisabled(link, opt) }"
                                          v-for="opt in daAddonOptionsByAddonName(linkIndex, 'Traffic Stability')"
                                          :key="opt.id"
                                      >
                                          <label>
                                              <input
                                                  type="checkbox"
                                                  :checked="link[getTrafficStabilityBoolKey(opt)]"
                                                  :disabled="isAddonOptionDisabled(link, opt)"
                                                  @change="
                                                      onToggleAddonOption(
                                                          linkIndex,
                                                          opt,
                                                          getTrafficStabilityBoolKey(opt),
                                                          $event.target.checked
                                                      )
                                                  "
                                              />
                                              <span>{{ opt.name }}</span>
                                              <span class="addon-price">+${{ numberFormat(opt.cost) }}</span>
                                          </label>
                                      </div>
                                  </div>
                              </div>

                              <div class="targeting-option-group">
                                  <label class="section-label">
                                      Spam Score
                                      <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.spamScore"></i>
                                  </label>
                                  <div class="checkbox-group">
                                      <div
                                          class="form-group checkbox"
                                          :class="{ 'addon-disabled': isAddonOptionDisabled(link, opt) }"
                                          v-for="opt in nonDaMultipleAddonOptionsByAddonName(linkIndex, 'Spam Score')"
                                          :key="opt.id"
                                      >
                                          <label>
                                              <input
                                                  type="checkbox"
                                                  :checked="link[getSpamScoreBoolKey(opt)]"
                                                  :disabled="isAddonOptionDisabled(link, opt)"
                                                  @change="
                                                      onToggleAddonOption(
                                                          linkIndex,
                                                          opt,
                                                          getSpamScoreBoolKey(opt),
                                                          $event.target.checked
                                                      )
                                                  "
                                              />
                                              <span>{{ opt.name }}</span>
                                              <span class="addon-price">+${{ numberFormat(opt.cost) }}</span>
                                          </label>
                                      </div>
                                  </div>
                              </div>

                              <div class="targeting-option-group">
                                  <label class="section-label">
                                      Review
                                      <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.review"></i>
                                  </label>
                                  <div class="checkbox-group">
                                      <template v-if="contentApprovalOptions(linkIndex).length">
                                          <div
                                              class="form-group checkbox"
                                              :class="{ 'addon-disabled': isAddonOptionDisabled(link, opt) }"
                                              v-for="opt in contentApprovalOptions(linkIndex)"
                                              :key="opt.id"
                                          >
                                              <label>
                                                  <input
                                                      type="checkbox"
                                                      :checked="isContentApprovalSelected(linkIndex, opt)"
                                                  :disabled="isAddonOptionDisabled(link, opt)"
                                                      @change="setContentApprovalSelected(linkIndex, $event.target.checked, opt)"
                                                  >
                                                  <span>{{ opt.name }}</span>
                                                  <span class="addon-price">+${{ numberFormat(opt.cost) }}</span>
                                              </label>
                                          </div>
                                      </template>
                                  </div>
                              </div>

                              <div class="targeting-option-group">
                                  <label class="section-label">
                                    RD/LD Ratio
                                      <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.rdldRatio"></i>
                                  </label>
                                  <div class="checkbox-group">
                                      <div
                                          class="form-group checkbox addon-conflict-tip-wrap"
                                          :class="{ 'addon-disabled': isAddonOptionDisabled(link, opt) || hasCftfRatioSelected(link) }"
                                          v-for="opt in nonDaMultipleAddonOptionsByAddonName(linkIndex, 'RD:LD Ratio')"
                                          :key="opt.id"
                                      >
                                          <label>
                                              <input
                                                  type="checkbox"
                                                  :checked="link[getRdldRatioBoolKey(opt)]"
                                                  :disabled="isAddonOptionDisabled(link, opt) || hasCftfRatioSelected(link)"
                                                  @change="
                                                      onToggleAddonOption(
                                                          linkIndex,
                                                          opt,
                                                          getRdldRatioBoolKey(opt),
                                                          $event.target.checked
                                                      )
                                                  "
                                              />
                                              <span>{{ opt.name }}</span>
                                              <span class="addon-price">+${{ numberFormat(opt.cost) }}</span>
                                          </label>
                                          <span
                                              v-if="rdldConflictTitle(link)"
                                              class="addon-conflict-tip"
                                          >{{ rdldConflictTitle(link) }}</span>
                                      </div>
                                  </div>
                              </div>

                              <div class="targeting-option-group">
                                  <label class="section-label">
                                    TF/CF Ratio
                                      <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.cftfRatio"></i>
                                  </label>
                                  <div class="checkbox-group">
                                      <div
                                          class="form-group checkbox addon-conflict-tip-wrap"
                                          :class="{ 'addon-disabled': isAddonOptionDisabled(link, opt) || hasRdldRatioSelected(link) }"
                                          v-for="opt in nonDaMultipleAddonOptionsByAddonName(linkIndex, 'CF:TF Ratio')"
                                          :key="opt.id"
                                      >
                                          <label>
                                              <input
                                                  type="checkbox"
                                                  :checked="link[getCftfRatioBoolKey(opt)]"
                                                  :disabled="isAddonOptionDisabled(link, opt) || hasRdldRatioSelected(link)"
                                                  @change="
                                                      onToggleAddonOption(
                                                          linkIndex,
                                                          opt,
                                                          getCftfRatioBoolKey(opt),
                                                          $event.target.checked
                                                      )
                                                  "
                                              />
                                              <span>{{ opt.name }}</span>
                                              <span class="addon-price">+${{ numberFormat(opt.cost) }}</span>
                                          </label>
                                          <span
                                              v-if="cftfConflictTitle(link)"
                                              class="addon-conflict-tip"
                                          >{{ cftfConflictTitle(link) }}</span>
                                      </div>
                                  </div>
                              </div>

                          </div>

                  <!-- Niche Purity Section -->
                  <div
                      class="niche-purity-section-box"
                      :class="{ 'addon-select-disabled': isPureNicheToggleDisabled(link) }"
                  >
                      <div class="niche-purity-content">
                          <label class="niche-purity-label">
                            Pure Niche
                              <i class="fas fa-info-circle" v-b-tooltip.hover.top="tooltips.nichePurity"></i>
                          </label>
                          <div class="niche-purity-toggle">
                              <div
                                  class="toggle-box addon-conflict-tip-wrap"
                                  :class="{ 'addon-select-disabled': isPureNicheToggleDisabled(link) }"
                              >
                                  <span 
                                      class="toggle-option" 
                                      :class="{ active: !link.nichePurity, 'toggle-option-disabled': isPureNicheToggleDisabled(link) }"
                                      @click="!isPureNicheToggleDisabled(link) && setNichePurity(linkIndex, false)"
                                  >No</span>
                                  <span 
                                      class="toggle-option" 
                                      :class="{ active: link.nichePurity, 'toggle-option-disabled': isPureNicheToggleDisabled(link) }"
                                      @click="!isPureNicheToggleDisabled(link) && setNichePurity(linkIndex, true)"
                                  >Yes</span>
                                  <span
                                      v-if="nicheConflictTitle(link)"
                                      class="addon-conflict-tip"
                                  >{{ nicheConflictTitle(link) }}</span>
                              </div>
                              <span class="addon-price"
                                  >+${{ numberFormat(getNichePurityCost(linkIndex)) }}</span
                              >
                          </div>
                          <div
                            class="possible-niches-wrapper"
                            v-if="
                              link.primary_category &&
                              (link.primary_category.relevant_category_lists || []).length
                            "
                          >
                            <span class="tags-label">Niches of Publishing Websites:</span>
                            <div class="niche-tags-list">
                              <span
                                v-for="(rel, idx) in link.primary_category.relevant_category_lists"
                                :key="idx"
                                class="niche-tag"
                              >
                                {{
                                  typeof rel === 'string'
                                    ? rel
                                    : rel?.name || rel
                                }}
                              </span>
                            </div>
                          </div>
                      </div>
                  </div>
                      </div>
                  </div>
                  </div>
              </div>
              <div class="action-buttons-section">
                    <button class="btn-add-link" type="button" @click="addLink('clickBtn')">
                        <i class="fas fa-plus"></i>
                        Add another link
                    </button>
                    <button class="btn-upload-csv" v-b-modal.modal-box-1 @click="trackBulkCsvUploadClick">
                        <i class="fas fa-upload"></i>
                        Upload CSV for bulk orders
                    </button>
                    <button class="btn-save-draft" type="button" @click="saveDraftOrder('custom')">
                        Save to Draft
                    </button>
                </div>
         
             
          </div>
          <CSVModal @on-upload="handleUploadedFile"></CSVModal>
      </section>
      <div class="new-product-page-btn-box">
                 <!-- Action Buttons Section -->


              <!-- Order Summary Section -->
                <div class="order-summary-section">
                    <div class="summary-left">
                        <div class="total-links-text">Total {{ links.length <= 1 ? "Link" : "Links" }}:
                          <span class="total-links-value">{{ links.length }}</span>
                        </div>
                        <div class="summary-middle">
                        <button class="btn-view-summary" type="button" @click="viewOrderSummary">
                            View Order Summary
                        </button>
                    </div>
                    </div>
                    <div class="summary-right">
                        <div class="total-amount">
                            <span class="total-label">Total</span>
                            <span class="total-value">USD ${{ numberFormat(grandTotal) }}</span>
                        </div>
                        <button class="btn-proceed-payment" type="button" @click="submit">
                            Proceed To Payment
                        </button>
                    </div>
                </div>
              </div>
  </div>
</template>
<script>
import { useToast } from "vue-toastification";
const toast = useToast();
import HeaderView from "@/components/layout/HeaderComponent.vue";
import CSVModal from "@/components/orderLinksComponents/AllModals.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import { numberFormat } from "@/prod.js";
import url from "@/prod.js";
import moment from "moment";
import swal from "sweetalert2";
import LZString from "lz-string";
import { getDraftInvoiceReady } from "@/utils/draftOrderPayValidation.js";
import { stripBrandMentionProducts, stripIndustryAddons, isBrandCategory } from "@/utils/brandMentionCatalog";
export default {
components: {
  HeaderView,
  CSVModal,
  LoaderComponent,
},
data() {
  return {
    numberFormat,
    currentDate: moment(new Date()).format("MM/DD/YYYY"),
    timer: null,
    isAutoSaving: false,
    isScrollTicking: false,
    /** Render links in chunks so 500+ rows do not freeze the main thread. Full data stays in `links`. */
    maxRenderedLinks: 50,
    loaded: true,
    loaderText: "",
    LZString,
    appStatus: url.appStatus,
    medium: "direct",
    source: "direct",
    campaign: "",
    webOrder: false,
    webOrderLinks: [],
    products: [],
    addon_products: [],
    form: {
      draft_order_id: "",
      order_title: "",
      created_by_id: ""
    },
    validation: {
      order_title: false,
      links: [],
    },
    links: [],
    categories: [],
    addon_da_options: [],
    trafficTLDMessage: "Please choose either the Traffic or TLD",
    tooltips: {
      metric: "DA of Moz | DR of Ahrefs",
      metricValue: "Minimum DA/DR of the website(s)",
      industry: "Select industry of your target URL",
      anchorText: "Clickable text in a hyperlink",
      secondaryCategory: "Secondary category refers to the sub or partial niche that your website may belong to",
      destinationUrl: "Page that backlink points to",
      traffic: "Monthly organic visitors of the website",
      country: "Country-specific TLD and/or source of top organic traffic",
      placementType:
        "Publish new post (Guest Post) or Insert your link in an existing post (Link Insertion)",
      nichePurity: "Websites that only works on one single niche.",
      trafficStability:
        "Exclude websites unnatural spikes and Google penalties.",
      spamScore: "Spam Score of Moz",
      review: "Review content before publishing.",
      rdldRatio:
        "Minimum ratio of Referring Domains compared to Linked Domains (Ahrefs metric)",
      cftfRatio:
        "Minimum ratio of Trust Flow compared to Citation Flow (Majestic's metric)",
      trafficDisabledByNiche:
        "Minimum Organic Traffic cannot be combined with Pure Niche.",
      nicheDisabledByTraffic:
        "Pure Niche cannot be combined with Minimum Organic Traffic.",
      rdldDisabledByCftf:
        "Only one ratio add-on can be selected. Disable TF/CF Ratio to enable RD/LD Ratio.",
      cftfDisabledByRdld:
        "Only one ratio add-on can be selected. Disable RD/LD Ratio to enable TF/CF Ratio.",
    },
    // CSV category migration map (old -> new).
    // Add more pairs here as legacy category names are discovered.
    categoryMigrationPairs: [
      { old: "Animals & Pets", new: "Pets" },
      { old: "App and SaaS", new: "SaaS and Apps" },
    ],
  };
},
async mounted() {
  this.checkUrlParams();
  await this.getProducts();
  await this.getAddonProducts();
  this.loaded = true;
  this.loaderText = "";

  const fromOrderSummaryBack =
    localStorage.getItem("from-order-summary-back") === "1";

  // Normal flow should only trust route id.
  // Back-from-summary flow can fallback to localStorage draft id.
  this.form.draft_order_id = this.$route?.params?.id || "";
  if (!this.form.draft_order_id && fromOrderSummaryBack) {
    this.form.draft_order_id = localStorage.getItem("draft-order-id") || "";
  }
  if (this.form.draft_order_id) {
    localStorage.setItem("draft-order-id", this.form.draft_order_id);
  } else if (!fromOrderSummaryBack) {
    localStorage.removeItem("draft-order-id");
  }

  if (fromOrderSummaryBack) {
    // Only in back-from-summary flow, restore from localStorage.
    this.form.order_title =
      localStorage.getItem("order-title") || this.form.order_title || "";
    const hydrated = this.hydrateFromLocalStorage();
    if (!hydrated) {
      if (this.form.draft_order_id) {
        await this.loadDraftOrder(this.form.draft_order_id);
      } else {
        this.addLink();
      }
    }
    localStorage.removeItem("from-order-summary-back");
  } else if (this.form.draft_order_id) {
    // Normal draft flow remains API-driven.
    await this.loadDraftOrder(this.form.draft_order_id);
  } else {
    this.addLink();
  }

  this.loaded = false;
  this.loaderText = "";

  // Avoid duplicating rows: draft load already hydrates links from API.
  // Web-order payload should only prefill on fresh/non-draft product page.
  if (this.webOrder && !this.form.draft_order_id) {
    this.webOrderLinksEdit();
  }

  this.timer = setInterval(() => {
    if (this.isAutoSaving) return;
    this.saveDraftOrder();
  }, 20000);
  window.addEventListener("scroll", this.onPageScroll, { passive: true });
  this.loaded = false;
},
beforeUnmount() {
  if (this.timer) clearInterval(this.timer);
  window.removeEventListener("scroll", this.onPageScroll);
},
computed: {
  grandTotal() {
    return (this.links || []).reduce((sum, l) => sum + (Number(l.total) || 0), 0);
  },
  trafficAddonProducts() {
    return (this.addon_products || []).filter((pd) => {
      const name = String(pd?.name || "").toLowerCase();
      return (
        pd?.dependent_da === "yes" &&
        pd?.type === "multiple" &&
        (name === "traffic" || name === "minimum traffic" || name.includes("minimum_traffic"))
      );
    });
  },
  trafficAddonProduct() {
    return this.trafficAddonProducts[0] || null;
  },
  /** Addon catalog row(s) whose name is Country — options list comes from DA addon rows with matching addon_id / addon_name. */
  countryAddonProducts() {
    return (this.addon_products || []).filter((pd) => {
      const name = String(pd?.name || "").trim().toLowerCase();
      return name === "country";
    });
  },
  countryAddonProduct() {
    return this.countryAddonProducts[0] || null;
  },
},
methods: {
  isLinkLockedByCustomPrice(link) {
    return !!(link?.custom_price_check && Number(link?.custom_price ?? 0) > 0);
  },
  resolveAddonCostForLink(link, computedCost) {
    if (this.isLinkLockedByCustomPrice(link)) return 0;
    return Number(computedCost) || 0;
  },
  getLinkBaseCostForAddons(link) {
    if (!link) return 0;
    if (this.isLinkLockedByCustomPrice(link)) return 0;
    return Number(link?.primary_category?.cost) || 0;
  },
  categoryPriceLabel(link, category) {
    const name = String(category?.name || "").trim();
    const isSelected =
      link?.primary_category?.id != null &&
      category?.id != null &&
      Number(link.primary_category.id) === Number(category.id);
    const price = this.isLinkLockedByCustomPrice(link) && isSelected
      ? Number(link?.custom_price ?? 0) || 0
      : Number(category?.cost || 0) || 0;
    return `${name} ($${this.numberFormat(price)})`;
  },
  isUserEmailVerified() {
    const authData = this.$store?.state?.Auth?.user?.data || {};
    return authData?.is_email_verified === true;
  },
  async ensureUserIsVerifiedBeforeProceed() {
    if (this.isUserEmailVerified()) return true;
    try {
      await this.$store.dispatch("Auth/getUserDataAction");
    } catch {
      // ignore refresh failure; fallback to current store state
    }
    if (this.isUserEmailVerified()) return true;
    this.loaded = false;
    await swal.fire({
      icon: "warning",
      text: "Please verify your email!",
    });
    return false;
  },
  /**
   * Convert order-summary / proceed() normalized link object into the same row shape
   * `loadDraftOrder` receives from the API.
   */
  storedLinkToDraftRow(stored) {
    const productName =
      (stored?.product &&
        typeof stored.product === "object" &&
        stored.product?.name) ||
      stored?.product_name ||
      "";
    const categoryName =
      (stored?.primary_category &&
        typeof stored.primary_category === "object" &&
        stored.primary_category?.name) ||
      stored?.category_name ||
      "";
    const customCheck = !!(stored?.custom_price_check ?? stored?.custom_price);
    const baseFromCategory = Number(
      stored?.primary_category?.total_cost ?? stored?.primary_category?.cost ?? 0
    );
    const linkPrice = customCheck
      ? Number(stored?.custom_price ?? 0) || 0
      : Number(stored?.total ?? 0) || baseFromCategory || 0;

    return {
      product_name: productName,
      category_name: categoryName,
      text: stored?.text || "",
      url: stored?.url || "",
      secondry_category: stored?.secondry_category ?? "",
      selected_category:
        stored?.selected_category ?? stored?.primary_category?.id ?? "",
      trialDA: stored?.trialDA,
      custom_price_check: customCheck,
      custom_price: stored?.custom_price,
      link_price: linkPrice,
      custom_price_value: stored?.custom_price_value,
      placement_url: stored?.placement_url ?? "",
      addons: Array.isArray(stored?.addons) ? stored.addons : [],
      link_notes:
        stored != null && Object.prototype.hasOwnProperty.call(stored, "link_notes")
          ? stored.link_notes ?? ""
          : "",
    };
  },
  /**
   * Same logic as draft API load — only the row source differs (API vs localStorage).
   */
  applyDraftOrderRow(row, idx) {
    const link = this.links[idx];

    link.draft_order_id = String(this.form.draft_order_id || "");
    link.order_title = String(this.form.order_title || "");

    const product = this.findProductByName(row.product_name);
    if (product) {
      link.metric = String(product.name || "").toUpperCase().startsWith("DR") ? "DR" : "DA";
      link.product = product;
      this.categories[idx] = this.getPrimaryCategories(product);
    }

    if (row.category_name && this.categories[idx]?.length) {
      const cat = this.findCategoryByName(idx, row.category_name);
      if (cat) link.primary_category = cat;
    }

    link.text = row.text || "";
    link.url = row.url || "";
    link.secondry_category = row.secondry_category || "";
    link.selected_category = row.selected_category ?? link.primary_category?.id ?? "";
    link.trialDA = row.trialDA ?? (link.product?.name === "DA 30+");
    link.custom_price_check = row.custom_price_check ?? row.custom_price ?? false;
    link.custom_price = row.link_price ?? row.custom_price_value ?? "";
    link.placement_url = row.placement_url ?? "";
    link.link_notes =
      row != null && Object.prototype.hasOwnProperty.call(row, "link_notes")
        ? row.link_notes ?? ""
        : "";
    // Build addon option prices after custom/base price is restored from draft.
    this.addon_da_options[idx] = this.getAddonDaOption(idx);

    if (Array.isArray(row.addons)) {
      const optionByName = new Map();
      const optionKey = (addonName, optionName) =>
        `${this.norm(addonName)}::${this.norm(optionName)}`;
      const pushOpts = (opts) =>
        (opts || []).forEach((o) => {
          optionByName.set(optionKey(o?.addon_name, o?.name), o);
        });

      pushOpts(this.addon_da_options[idx]);
      pushOpts(this.daAddonOptionsByAddonName(idx, "Traffic Stability"));
      pushOpts(this.nonDaMultipleAddonOptionsByAddonName(idx, "Spam Score"));
      pushOpts(this.nonDaMultipleAddonOptionsByAddonName(idx, "RD:LD Ratio"));
      pushOpts(this.nonDaMultipleAddonOptionsByAddonName(idx, "CF:TF Ratio"));
      pushOpts(this.contentApprovalOptions(idx));
      const np = this.getNichePurityOption(idx);
      if (np) {
        optionByName.set(optionKey(np?.addon_name, np?.name), np);
      }

      link.addons = row.addons
        .map((a) => {
          const matched = optionByName.get(optionKey(a?.addon_name, a?.name));
          // Drop addons no longer available in catalog (inactive/deleted).
          return matched || null;
        })
        .filter(Boolean);

      link.trafficStability6 = false;
      link.trafficStability12 = false;
      link.spamScore5 = false;
      link.spamScore1 = false;
      link.rdldRatio1 = false;
      link.rdldRatio2 = false;
      link.cftfRatio1 = false;
      link.cftfRatio2 = false;
      link.nichePurity = false;

      const hasAddonOption = (addonLabel, optionNeedle) =>
        link.addons.some((ad) => {
          const addon = this.norm(ad?.addon_name);
          const name = this.norm(ad?.name);
          return addon.includes(this.norm(addonLabel)) && name.includes(this.norm(optionNeedle));
        });

      link.trafficStability6 = hasAddonOption("Traffic Stability", "6 month");
      link.trafficStability12 = hasAddonOption("Traffic Stability", "12 month");
      link.spamScore5 = hasAddonOption("Spam Score", "5%");
      link.spamScore1 = hasAddonOption("Spam Score", "1%");
      link.rdldRatio1 = hasAddonOption("RD:LD Ratio", "1:1");
      link.rdldRatio2 = hasAddonOption("RD:LD Ratio", "2:1");
      link.cftfRatio1 = hasAddonOption("CF:TF Ratio", "1:1");
      link.cftfRatio2 = hasAddonOption("CF:TF Ratio", "2:1");
      link.nichePurity = link.addons.some((ad) =>
        this.norm(ad?.addon_name).includes("niche purity")
      );

      const trafficIds = new Set((this.trafficAddonProducts || []).map((pd) => pd.id));
      const trafficAddon = link.addons.find((ad) => trafficIds.has(ad?.addon_id));
      if (trafficAddon) {
        link.traffic_selected_addon = JSON.stringify(trafficAddon);
        const trafficJson = JSON.stringify(trafficAddon);
        link.da_fixed_addons = null;
        link.da_percentage_addons = null;

        if (trafficAddon?.price_type === "percentage") {
          link.da_percentage_addons = trafficJson;
          link.isDaAddonPercentage = false;
          link.isDaAddonFixed = true;
        } else {
          link.da_fixed_addons = trafficJson;
          link.isDaAddonFixed = false;
          link.isDaAddonPercentage = true;
        }
      }

      const countryIds = new Set((this.countryAddonProducts || []).map((pd) => pd.id));
      const countryAddon = link.addons.find((ad) => {
        if (countryIds.size) return countryIds.has(ad?.addon_id);
        return this.norm(ad?.addon_name) === "country";
      });
      if (countryAddon) {
        link.country_selected_addon = JSON.stringify(countryAddon);
        const countryJson = JSON.stringify(countryAddon);
        if (!trafficAddon) {
          link.da_fixed_addons = null;
          link.da_percentage_addons = null;
          if (countryAddon?.price_type === "percentage") {
            link.da_percentage_addons = countryJson;
            link.isDaAddonPercentage = false;
            link.isDaAddonFixed = true;
          } else {
            link.da_fixed_addons = countryJson;
            link.isDaAddonFixed = false;
            link.isDaAddonPercentage = true;
          }
        } else {
          const tPct = trafficAddon?.price_type === "percentage";
          const cPct = countryAddon?.price_type === "percentage";
          if (tPct !== cPct) {
            if (cPct) {
              link.da_percentage_addons = countryJson;
            } else {
              link.da_fixed_addons = countryJson;
            }
          }
        }
      }
    }

    this.enforceCountryAddonRestrictions(idx);
    this.enforceNicheTrafficMutualExclusion(idx);
    this.enforceRatioAddonMutualExclusion(idx);
    this.pruneUnavailableLinkAddons(idx);
    this.refreshAddonCosts(idx);
    this.updateLinkTotal(idx);
  },
  hydrateFromLocalStorage() {
    let parsed = [];
    try {
      parsed = JSON.parse(LZString.decompress(localStorage.getItem("links")) || "[]");
    } catch {
      parsed = [];
    }
    if (!Array.isArray(parsed) || parsed.length === 0) return false;

    this.links = [];
    this.categories = [];
    this.addon_da_options = [];
    this.validation.links = [];

    parsed.forEach((stored) => {
      const row = this.storedLinkToDraftRow(stored);
      this.addLink("clickBtn");
      const idx = this.links.length - 1;
      this.applyDraftOrderRow(row, idx);
    });

    this.maxRenderedLinks = Math.min(50, Math.max(1, this.links.length));
    return this.links.length > 0;
  },
  getQueryParameterValue(parameterName) {
    const queryString = location.search.substring(1);
    const queryParams = queryString.split("&");
    for (let i = 0; i < queryParams.length; i++) {
      const param = queryParams[i].split("=");
      if (param[0] === parameterName) {
        return decodeURIComponent(param[1] || "");
      }
    }
    return null;
  },
  checkUrlParams() {
    // ProductPage supports both `source=ppc` and UTM-style params.
    const sourceValue =
      this.getQueryParameterValue("source") ||
      this.getQueryParameterValue("utm_source");
    const mediumValue =
      this.getQueryParameterValue("medium") ||
      this.getQueryParameterValue("utm_medium");
    const campaignValue = this.getQueryParameterValue("utm_campaign");
    const webOrder = this.getQueryParameterValue("order");

    if (sourceValue) this.source = sourceValue;
    if (mediumValue) this.medium = mediumValue;
    if (campaignValue) this.campaign = campaignValue;

    if (webOrder) {
      try {
        this.webOrder = true;
        this.webOrderLinks = JSON.parse(atob(webOrder));
      } catch {
        this.webOrder = false;
        this.webOrderLinks = [];
      }
    }
  },
  webOrderLinksEdit() {
    (this.webOrderLinks || []).forEach((row) => {
      // Mirror ProductPage behavior: if last link is already filled, add new.
      let index = this.links.length - 1;
      const last = this.links[index];
      if (!last || last.product) {
        this.addLink("clickBtn");
        index = this.links.length - 1;
      }

      const link = this.links[index];

      // Product
      const product = this.findProductByName(row?.product_name);
      if (product) {
        link.metric = String(product.name || "").toUpperCase().startsWith("DR") ? "DR" : "DA";
        link.product = product;
        this.categories[index] = this.getPrimaryCategories(product);
      }

      // Category
      if (row?.category_name && this.categories[index]?.length) {
        const cat = this.findCategoryByName(index, row.category_name);
        if (cat) link.primary_category = cat;
      }

      // Build DA addon options for this link
      this.addon_da_options[index] = this.getAddonDaOption(index);

      // Mark addon sections active (ProductPage parity)
      link.isDaAddonActive = true;
      link.isAddonActive = true;
      link.isAddon = false;
      link.isCopy = false;

      // Addons restore (map using addon_name + option name to avoid collisions)
      if (Array.isArray(row?.addons)) {
        const optionByKey = new Map();
        const keyOf = (addonName, optionName) =>
          `${this.norm(addonName)}::${this.norm(optionName)}`;

        const pushOpts = (opts) =>
          (opts || []).forEach((o) => {
            optionByKey.set(keyOf(o?.addon_name, o?.name), o);
          });

        pushOpts(this.addon_da_options[index]);
        pushOpts(this.daAddonOptionsByAddonName(index, "Traffic Stability"));
        pushOpts(this.nonDaMultipleAddonOptionsByAddonName(index, "Spam Score"));
        pushOpts(this.nonDaMultipleAddonOptionsByAddonName(index, "RD:LD Ratio"));
        pushOpts(this.nonDaMultipleAddonOptionsByAddonName(index, "CF:TF Ratio"));
        pushOpts(this.contentApprovalOptions(index));
        const np = this.getNichePurityOption(index);
        if (np) optionByKey.set(keyOf(np?.addon_name, np?.name), np);

        link.addons = row.addons
          .map((a) => optionByKey.get(keyOf(a?.addon_name, a?.name)) || null)
          .filter(Boolean);

        // Restore checkboxes states safely (addon group + option)
        link.trafficStability6 = false;
        link.trafficStability12 = false;
        link.spamScore5 = false;
        link.spamScore1 = false;
        link.rdldRatio1 = false;
        link.rdldRatio2 = false;
        link.cftfRatio1 = false;
        link.cftfRatio2 = false;
        link.nichePurity = false;

        const hasAddonOption = (addonLabel, optionNeedle) =>
          link.addons.some((ad) => {
            const addon = this.norm(ad?.addon_name);
            const name = this.norm(ad?.name);
            return addon.includes(this.norm(addonLabel)) && name.includes(this.norm(optionNeedle));
          });

        link.trafficStability6 = hasAddonOption("Traffic Stability", "6 month");
        link.trafficStability12 = hasAddonOption("Traffic Stability", "12 month");
        link.spamScore5 = hasAddonOption("Spam Score", "5%");
        link.spamScore1 = hasAddonOption("Spam Score", "1%");
        link.rdldRatio1 = hasAddonOption("RD:LD Ratio", "1:1");
        link.rdldRatio2 = hasAddonOption("RD:LD Ratio", "2:1");
        link.cftfRatio1 = hasAddonOption("CF:TF Ratio", "1:1");
        link.cftfRatio2 = hasAddonOption("CF:TF Ratio", "2:1");
        link.nichePurity = link.addons.some((ad) =>
          this.norm(ad?.addon_name).includes("niche purity")
        );

        // Restore traffic dropdown / da_fixed_addons / da_percentage_addons
        const trafficIds = new Set((this.trafficAddonProducts || []).map((pd) => pd.id));
        const trafficAddon = link.addons.find((ad) => trafficIds.has(ad?.addon_id));
        if (trafficAddon) {
          link.traffic_selected_addon = JSON.stringify(trafficAddon);
          const trafficJson = JSON.stringify(trafficAddon);
          link.da_fixed_addons = null;
          link.da_percentage_addons = null;
          if (trafficAddon?.price_type === "percentage") {
            link.da_percentage_addons = trafficJson;
            link.isDaAddonPercentage = false;
            link.isDaAddonFixed = true;
          } else {
            link.da_fixed_addons = trafficJson;
            link.isDaAddonFixed = false;
            link.isDaAddonPercentage = true;
          }
        }

        const countryIds = new Set((this.countryAddonProducts || []).map((pd) => pd.id));
        const countryAddon = link.addons.find((ad) => {
          if (countryIds.size) return countryIds.has(ad?.addon_id);
          return this.norm(ad?.addon_name) === "country";
        });
        if (countryAddon) {
          link.country_selected_addon = JSON.stringify(countryAddon);
          const countryJson = JSON.stringify(countryAddon);
          if (!trafficAddon) {
            link.da_fixed_addons = null;
            link.da_percentage_addons = null;
            if (countryAddon?.price_type === "percentage") {
              link.da_percentage_addons = countryJson;
              link.isDaAddonPercentage = false;
              link.isDaAddonFixed = true;
            } else {
              link.da_fixed_addons = countryJson;
              link.isDaAddonFixed = false;
              link.isDaAddonPercentage = true;
            }
          } else {
            const tPct = trafficAddon?.price_type === "percentage";
            const cPct = countryAddon?.price_type === "percentage";
            if (tPct !== cPct) {
              if (cPct) {
                link.da_percentage_addons = countryJson;
              } else {
                link.da_fixed_addons = countryJson;
              }
            }
          }
        }
      }

      // ProductPage web-order clears text/url/etc.
      link.text = "";
      link.url = "";
      link.secondry_category = "";
      link.draft_order_id = "";
      link.order_title = "";

      this.enforceCountryAddonRestrictions(index);
      this.enforceNicheTrafficMutualExclusion(index);
      this.enforceRatioAddonMutualExclusion(index);
      this.pruneUnavailableLinkAddons(index);
      this.refreshAddonCosts(index);
      this.updateLinkTotal(index);
    });
  },
  norm(v) {
    return String(v ?? "").trim().toLowerCase();
  },
  parseSelectedCountryName(link) {
    if (!link?.country_selected_addon || link.country_selected_addon === "null") {
      return "united states";
    }
    try {
      const parsed = JSON.parse(link.country_selected_addon);
      return this.norm(parsed?.name);
    } catch {
      return "";
    }
  },
  isCountryTrafficLimitedToFiveK(link) {
    const country = this.parseSelectedCountryName(link);
    return new Set([
      "new zealand",
      "united arab emirates",
      "germany",
      "france",
      "netherlands",
      "denmark",
      "finland",
      "italy",
      "spain",
      "sweden",
      "argentina",
      "switzerland",
      "belgium",
      "mexico",
      "greece",
      "hungary",
      "austria",
    ]).has(country);
  },
  isPureNicheDisabledForCountry(link) {
    const country = this.parseSelectedCountryName(link);
    return new Set([
      "new zealand",
      "united arab emirates",
      "germany",
      "france",
      "netherlands",
      "denmark",
      "finland",
      "italy",
      "spain",
      "sweden",
      "argentina",
      "switzerland",
      "belgium",
      "mexico",
      "greece",
      "hungary",
      "austria",
    ]).has(country);
  },
  isTrafficOptionFiveK(opt) {
    const raw = String(opt?.name || "").toLowerCase().replace(/,/g, " ");
    const hasFiveKLabel = /\b5k\b/.test(raw);
    const hasExactFiveThousand = /(^|[^\d])5000(?!\d)/.test(raw.replace(/\s+/g, ""));
    return hasFiveKLabel || hasExactFiveThousand;
  },
  trafficOptionNumericValue(opt) {
    const raw = String(opt?.name || "").toLowerCase();
    if (/\b5k\b/.test(raw)) return 5000;
    const compact = raw.replace(/,/g, "");
    const matches = compact.match(/\d+/g) || [];
    if (!matches.length) return null;
    return Number(matches[matches.length - 1]) || null;
  },
  isTrafficOptionAtOrBelowFiveK(opt) {
    const value = this.trafficOptionNumericValue(opt);
    if (value == null) return false;
    return value <= 5000;
  },
  isTrafficOptionZero(opt) {
    const value = this.trafficOptionNumericValue(opt);
    if (value == null) return false;
    return value === 0;
  },
  isAddonCostPositive(opt, link = null) {
    const resolvedCost = this.resolveAddonCostForLink(link, opt?.cost);
    return Number(resolvedCost) > 0;
  },
  hasFiveKTrafficOption(index) {
    const options = this.trafficAddonOptions(index, { bypassCountryLimit: true });
    return options.some((o) => this.isTrafficOptionFiveK(o));
  },
  enforceCountryAddonRestrictions(index) {
    const link = this.links[index];
    if (!link) return;

    if (this.isPureNicheDisabledForCountry(link)) {
      link.nichePurity = false;
      link.addons = (link.addons || []).filter(
        (a) => !this.norm(a?.addon_name).includes("niche purity")
      );
    }

    if (this.isCountryTrafficLimitedToFiveK(link) && this.hasFiveKTrafficOption(index)) {
      let selectedTraffic = null;
      try {
        selectedTraffic =
          link.traffic_selected_addon && link.traffic_selected_addon !== "null"
            ? JSON.parse(link.traffic_selected_addon)
            : null;
      } catch {
        selectedTraffic = null;
      }
      if (selectedTraffic && !this.isTrafficOptionAtOrBelowFiveK(selectedTraffic)) {
        this.onTrafficSelect(index, "null");
      }
    }
  },
  enforceNicheTrafficMutualExclusion(index) {
    const link = this.links[index];
    if (!link?.nichePurity) return;

    // Niche selected => Minimum Organic Traffic is cleared/disabled.
    // Stable Traffic Graph stays independent.
    if (this.hasSelectedTrafficAddon(link)) {
      this.onTrafficSelect(index, "null");
    }
  },
  isCatalogAddonOptionAvailable(opt) {
    if (!opt) return false;
    const active = opt.active ?? opt.is_active ?? opt?.addons_data?.active;
    if (active === 0 || active === false || active === "0") return false;
    const deleted =
      opt.delete ??
      opt.deleted ??
      opt.is_deleted ??
      opt?.addons_data?.delete ??
      opt?.addons_data?.deleted ??
      opt?.addons_data?.is_deleted;
    if (deleted === 1 || deleted === true || deleted === "1") return false;
    return true;
  },
  getAvailableAddonOptionsById(index) {
    const optionById = new Map();
    const push = (opts) =>
      (opts || []).forEach((o) => {
        if (o?.id == null) return;
        optionById.set(Number(o.id), o);
      });

    push(this.addon_da_options[index] || []);
    push(this.daAddonOptionsByAddonName(index, "Traffic Stability"));
    push(this.nonDaMultipleAddonOptionsByAddonName(index, "Spam Score"));
    push(this.nonDaMultipleAddonOptionsByAddonName(index, "RD:LD Ratio"));
    push(this.nonDaMultipleAddonOptionsByAddonName(index, "CF:TF Ratio"));
    push(this.contentApprovalOptions(index));
    const np = this.getNichePurityOption(index);
    if (np?.id != null) optionById.set(Number(np.id), np);
    return optionById;
  },
  pruneUnavailableLinkAddons(index) {
    const link = this.links[index];
    if (!link) return;

    const availableById = this.getAvailableAddonOptionsById(index);
    const availableByKey = new Map();
    availableById.forEach((o) => {
      availableByKey.set(
        `${this.norm(o?.addon_name)}::${this.norm(o?.name)}`,
        o
      );
    });

    link.addons = (link.addons || [])
      .map((a) => {
        if (a?.id != null && availableById.has(Number(a.id))) {
          return availableById.get(Number(a.id));
        }
        const key = `${this.norm(a?.addon_name)}::${this.norm(a?.name)}`;
        return availableByKey.get(key) || null;
      })
      .filter(Boolean);

    // Keep checkbox/toggle flags aligned with remaining available addons.
    const hasAddonOption = (addonLabel, optionNeedle) =>
      link.addons.some((ad) => {
        const addon = this.norm(ad?.addon_name);
        const name = this.norm(ad?.name);
        return (
          addon.includes(this.norm(addonLabel)) &&
          name.includes(this.norm(optionNeedle))
        );
      });

    link.trafficStability6 = hasAddonOption("Traffic Stability", "6 month");
    link.trafficStability12 = hasAddonOption("Traffic Stability", "12 month");
    link.spamScore5 = hasAddonOption("Spam Score", "5%");
    link.spamScore1 = hasAddonOption("Spam Score", "1%");
    link.rdldRatio1 = hasAddonOption("RD:LD Ratio", "1:1");
    link.rdldRatio2 = hasAddonOption("RD:LD Ratio", "2:1");
    link.cftfRatio1 = hasAddonOption("CF:TF Ratio", "1:1");
    link.cftfRatio2 = hasAddonOption("CF:TF Ratio", "2:1");
    link.nichePurity = link.addons.some((ad) =>
      this.norm(ad?.addon_name).includes("niche purity")
    );

    // Clear traffic selection if no longer in catalog/addons.
    const trafficIds = new Set((this.trafficAddonProducts || []).map((pd) => pd.id));
    const hasTraffic = link.addons.some((ad) => trafficIds.has(ad?.addon_id));
    if (!hasTraffic && this.hasSelectedTrafficAddon(link)) {
      this.onTrafficSelect(index, "null");
    }

    const countryIds = new Set((this.countryAddonProducts || []).map((pd) => pd.id));
    const hasCountry = link.addons.some((ad) => {
      if (countryIds.size) return countryIds.has(ad?.addon_id);
      return this.norm(ad?.addon_name) === "country";
    });
    if (
      !hasCountry &&
      link.country_selected_addon &&
      link.country_selected_addon !== "null"
    ) {
      this.onCountrySelect(index, "null");
    }
  },
  pickAddonsByName(link, needle) {
    const n = this.norm(needle);
    return (link?.addons || []).filter((a) =>
      this.norm(a?.addon_name || a?.name).includes(n)
    );
  },
  mergeAddonsById(link, addonsToAdd) {
    const existing = new Set((link?.addons || []).map((a) => a?.id));
    const toAdd = (addonsToAdd || []).filter((a) => a?.id != null && !existing.has(a.id));
    link.addons = [...(link.addons || []), ...toAdd];
  },
  async getProducts() {
    try {
      const res = await this.$store.dispatch("Product/getProductDataAction");
      this.products = stripBrandMentionProducts(res?.products || []);
    } catch (e) {
      this.products = [];
    }
  },
  async getAddonProducts() {
    try {
      const res = await this.$store.dispatch("Product/getAddonProductDataAction");
      this.addon_products = stripIndustryAddons(res?.addon_products || []);
    } catch (e) {
      this.addon_products = [];
    }
  },
  async loadDraftOrder(id) {
    try {
      const res = await this.$store.dispatch("Link/getEditLinksDataAction", id);
      if (!res?.draft_order) {
        toast.error("Draft Order Already Deleted", { timeout: 3000 });
        localStorage.removeItem("draft-order-id");
        this.$router.push("/dashboard");
        return;
      }

      this.form.order_title = res.draft_order.order_title || "";
      this.form.draft_order_id = String(res.draft_order.id || id);
      this.form.created_by_id = res.draft_order.created_by;


      let parsedLinks = [];
      try {
        parsedLinks = JSON.parse(res.draft_order.links || "[]");
      } catch {
        parsedLinks = [];
      }

      // Reset existing state
      this.links = [];
      this.categories = [];
      this.addon_da_options = [];

      parsedLinks.forEach((row) => {
        this.addLink("clickBtn");
        const idx = this.links.length - 1;
        this.applyDraftOrderRow(row, idx);
      });

      this.maxRenderedLinks = Math.min(50, Math.max(1, this.links.length));

      if (this.links.length === 0) {
        this.addLink();
      }
    } catch (e) {
      if (e?.response?.data?.error === "Access Denied") {
        localStorage.removeItem("draft-order-id");
        this.$router.push("/dashboard");
        return;
      }
      // fallback: show blank form
      if (this.links.length === 0) this.addLink();
    }
  },
  async saveDraftOrder(saveByUser) {
    const isAutoSave = saveByUser !== "custom";
    if (isAutoSave && this.isAutoSaving) return;
    if (isAutoSave) this.isAutoSaving = true;

    if (!this.form.order_title && saveByUser !== "custom") {
      this.form.order_title = `Draft Autosaved ${this.currentDate}`;
    }

    if (saveByUser === "custom") {
      if (!this.form.order_title) {
        toast.error("Please fill order title first!", { timeout: 3000 });
        return;
      }
      this.loaderText = "";
      this.loaded = true;
    }

    try {
      // Drop inactive/deleted catalog options, then reprice.
      (this.links || []).forEach((_, i) => {
        this.pruneUnavailableLinkAddons(i);
        this.refreshAddonCosts(i);
      });

      const draft_links = (this.links || []).map((link) => ({
        product_name: link.product
          ? link.product.name
          : link.metricProduct
            ? link.metricProduct.name
            : "",
        text: link.text || link.anchorText || "",
        url: link.url || link.destinationUrl || "",
        category_name: link.primary_category ? link.primary_category.name : "",
        secondry_category: link.secondry_category ?? "",
        addons: link.addons || [],
        order_title: this.form.order_title,
        draft_order_id: this.form.draft_order_id,
        link_price: link.custom_price_check
          ? Number(link.custom_price ?? 0) || 0
          : Number(link.total) || 0,
        custom_price: !!link.custom_price_check,
        placement_url: link.placement_url ?? "",
        link_notes:
          link != null && Object.prototype.hasOwnProperty.call(link, "link_notes")
            ? link.link_notes ?? ""
            : "",
      }));

      const res = await this.$store.dispatch(
        "Product/saveDraftOrderAction",
        {
          order_type: "normal",
          order_title: this.form.order_title,
          total: this.grandTotal,
          links: draft_links,
            order_medium: this.medium,
            order_source: this.source,
          package_id: 0,
          invoice_ready: getDraftInvoiceReady({
            order_title: this.form.order_title,
            order_type: "normal",
            links: draft_links,
          }),
        },
        { root: true }
      );

      if (res?.success) {
        if (res.draft_order_id && this.form.draft_order_id !== res.draft_order_id) {
          this.form.draft_order_id = res.draft_order_id;
          localStorage.setItem("draft-order-id", res.draft_order_id);
          // Mirror ProductPage behavior: draft id appears in URL after autosave.
          if (this.$route?.name === "product") {
            this.$router.replace({
              name: "product",
              params: { id: res.draft_order_id },
              query: this.$route.query,
            });
          }
        }
        this.trackAddToCartForDraft(
          draft_links,
          this.grandTotal,
          res?.draft_order_id || this.form.draft_order_id,
          saveByUser
        );
        if (saveByUser === "custom") {
          toast.success(res.message || "Draft saved", { timeout: 3000 });
          this.$router.push({
            path: "/draft-order",
            query: this.$route.query,
          });
        }
      }
    } catch (e) {
      if (saveByUser === "custom") {
        toast.error("Failed to save draft", { timeout: 3000 });
      }
    } finally {
      if (isAutoSave) {
        this.isAutoSaving = false;
      }
      if (saveByUser === "custom") {
        this.loaderText = "";
        this.loaded = false;
      }
    }
  },
  submit() {
    this.loaded = true;
    setTimeout(() => {
      localStorage.removeItem("order-summary-show-review");
      this.proceed();
    }, 300);
  },
  trackAddToCartForDraft(draftLinks, total, transactionId, saveByUser) {
    if (this.appStatus !== "production") return;
    if (typeof window === "undefined") return;

    const links = Array.isArray(draftLinks) ? draftLinks : [];
    const items = links.map((link, index) => ({
      item_id: String(index + 1),
      item_name: String(link?.product_name || "Unknown Product"),
      item_category: String(link?.category_name || "Unknown Category"),
      price: Number(link?.link_price ?? 0),
      quantity: 1,
    }));

    const resolvedTransactionId =
      String(transactionId || this.form.draft_order_id || "").trim() ||
      `draft-${Date.now()}`;
    const orderType = saveByUser === "custom" ? "manual_draft" : "auto_draft";
    const resolvedTotal = Number(total || 0);

    const payload = {
      event: "add_to_cart",
      currency: "USD",
      transaction_id: resolvedTransactionId,
      value: resolvedTotal,
      order_type: orderType,
      items,
      ecommerce: {
        currency: "USD",
        transaction_id: resolvedTransactionId,
        value: resolvedTotal,
        order_type: orderType,
        items,
      },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  },
  trackBeginCheckout(normalizedLinks, total) {
    if (this.appStatus !== "production") return;
    if (typeof window === "undefined") return;
    const links = Array.isArray(normalizedLinks) ? normalizedLinks : [];
    const items = links.map((link, index) => {
      const basePrice =
        link?.custom_price_check === true
          ? Number(link?.custom_price ?? 0)
          : Number(link?.primary_category?.total_cost ?? 0);
      return {
        item_id: String(link?.id ?? index + 1),
        item_name: String(link?.product?.name ?? "Unknown Product"),
        item_category: String(link?.primary_category?.name ?? "Unknown Category"),
        price: Number(basePrice || 0),
        quantity: 1,
      };
    });

    const payload = {
      event: "begin_checkout",
      currency: "USD",
      value: Number(total || 0),
      items,
      ecommerce: {
        currency: "USD",
        value: Number(total || 0),
        items,
      },
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  },
  trackBulkCsvUploadClick() {
    if (this.appStatus !== "production") return;
    if (typeof window === "undefined") return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "Upload_CSV_for_bulk_orders",
      order_type: "bulk",
      upload_method: "csv",
    });
  },
  viewOrderSummary() {
    this.loaded = true;
    setTimeout(() => {
      localStorage.setItem("order-summary-show-review", "1");
      this.proceed();
    }, 300);
  },
  proceed() {
    this.ensureUserIsVerifiedBeforeProceed().then((isVerified) => {
      if (!isVerified) return;
    // Per-tab flow marker (sessionStorage is tab-scoped, unlike localStorage).
    sessionStorage.setItem("payment-flow-type", "normal");
    // reset validation flags
    this.validation.order_title = false;
    (this.validation.links || []).forEach((v) => {
      v.product = false;
      v.primary_category = false;
      v.secondry_category = false;
      v.text = false;
      v.url = false;
    });

    if (!this.form.order_title) {
      this.validation.order_title = true;
      this.loaded = false;
      swal.fire({
        icon: "warning",
        text: "Please fill order title first!",
        willClose: () => {
          this.handleValidationScroll();
        },
      });
      return;
    }

    let errCount = 0;
    let urlErrCount = 0;
    (this.links || []).forEach((link, index) => {
      if (!link.product) {
        this.validation.links[index].product = true;
        errCount += 1;
      }
      const industryStillAvailable = (this.categories[index] || []).some(
        (c) => Number(c.id) === Number(link.primary_category?.id)
      );
      if (!link.primary_category || !industryStillAvailable) {
        if (link.primary_category) {
          link.primary_category = null;
          this.updateLinkTotal(index);
        }
        this.validation.links[index].primary_category = true;
        errCount += 1;
      }
      if (!String(link.text || "").trim()) {
        this.validation.links[index].text = true;
        errCount += 1;
      }
      if (!String(link.secondry_category || "").trim()) {
        this.validation.links[index].secondry_category = true;
        errCount += 1;
      }
      if (!String(link.url || "").trim()) {
        this.validation.links[index].url = true;
        errCount += 1;
      }
    });

    if (errCount > 0) {
      this.loaded = false;
      swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill all the required fields!",
        willClose: () => {
          this.handleValidationScroll();
        },
      });
      return;
    }

    (this.links || []).forEach((link, index) => {
      const destURL = String(link.url || "").trim().toLowerCase();
      if (destURL && !this.isValidURL(destURL)) {
        this.validation.links[index].url = true;
        urlErrCount += 1;
      }
    });

    if (urlErrCount > 0) {
      this.loaded = false;
      swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please enter a valid URL!",
        willClose: () => {
          this.handleValidationScroll();
        },
      });
      return;
    }

    // Drop inactive/deleted addons, then keep costs accurate before persist.
    (this.links || []).forEach((_, i) => {
      this.pruneUnavailableLinkAddons(i);
      this.refreshAddonCosts(i);
      this.updateLinkTotal(i);
    });

    // IMPORTANT: `PaymentPage.vue` expects `links` in the same structure as
    // `ProductPage.vue` creates (keys like `product`, `text`, `url`, and
    // `primary_category.total_cost`).
    const normalizedLinks = (this.links || []).map((link) => {
      // Build a payload that matches `ProductPage.vue`'s `links` objects.
      // (Exclude NewProductPage-only UI state like country/ratios/hyperTargetingExpanded.)

      const product = link?.product ?? link?.metricProduct ?? null;
      const rawPrimary = link?.primary_category ?? null;
      const primary_category = rawPrimary
        ? {
            id: rawPrimary?.id ?? null,
            name: rawPrimary?.name ?? "",
            cost: Number(rawPrimary?.cost ?? rawPrimary?.total_cost ?? 0),
            product_cost: Number(product?.cost ?? 0),
            total_cost: Number(
              rawPrimary?.total_cost ?? rawPrimary?.cost ?? 0
            ),
            special: rawPrimary?.special,
          }
        : null;

      const baseCost = Number(primary_category?.total_cost ?? 0);
      const daFixedSelected =
        link?.da_fixed_addons && link.da_fixed_addons !== "null";
      const daPercentSelected =
        link?.da_percentage_addons && link.da_percentage_addons !== "null";

      const computedIsDaAddonFixed = daFixedSelected
        ? false
        : daPercentSelected
          ? true
          : link?.isDaAddonFixed ?? true;
      const computedIsDaAddonPercentage = daPercentSelected
        ? false
        : daFixedSelected
          ? true
          : link?.isDaAddonPercentage ?? true;

      const isDaAddonActive = !!primary_category;
      const isAddonActive = !!primary_category;

      const custom_price_check = !!link?.custom_price_check;

      // Mirror ProductPage: `custom_price` should represent base/link price.
      const custom_price = custom_price_check
        ? Number(link?.custom_price ?? baseCost)
        : baseCost;

      return {
        id: link?.id ?? "",
        product,
        product_type: link?.product_type ?? null,
        exact_da_dr: link?.exact_da_dr ?? null,
        addons: link?.addons || [],
        text: link?.text ?? link?.anchorText ?? "",
        url: link?.url ?? link?.destinationUrl ?? "",
        primary_category,
        secondry_category: link?.secondry_category ?? "",
        selected_category:
          link?.selected_category ??
          (primary_category ? primary_category.id : null) ??
          "",

        // DA-related addon selections (stored as JSON strings).
        da_fixed_addons: link?.da_fixed_addons ?? null,
        da_percentage_addons: link?.da_percentage_addons ?? null,

        // Keep these keys for parity with ProductPage payload.
        fixed_addons: link?.fixed_addons ?? null,
        percentage_addons: link?.percentage_addons ?? null,

        // Flags (do not hardcode; match existing link state).
        trialDA: link?.trialDA ?? false,
        isDaAddonFixed: computedIsDaAddonFixed,
        isDaAddonPercentage: computedIsDaAddonPercentage,
        isAddon: false,
        isCopy: false,
        isDaAddonActive,
        isAddonActive,

        draft_order_id:
          link?.draft_order_id ?? this.form.draft_order_id ?? "",
        order_title:
          link?.order_title ?? this.form.order_title ?? "",

        total: Number(link?.total ?? 0),
        custom_price_check,
        custom_price,
        placement_url: link?.placement_url ?? "",
        link_notes: link?.link_notes ?? "",
        created_by_id: link?.created_by_id ?? this.form.created_by_id ?? "",
      };
    });

    const linkTotal = normalizedLinks.reduce((sum, l) => {
      const base =
        l?.custom_price_check === true
          ? Number(l?.custom_price ?? 0)
          : Number(l?.primary_category?.total_cost ?? 0);
      return sum + base;
    }, 0);

    const addonTotal = normalizedLinks.reduce((sum, l) => {
      return (
        sum +
        (l?.addons || []).reduce((s, a) => s + Number(a?.cost ?? 0), 0)
      );
    }, 0);

    const addonCount = normalizedLinks.reduce((sum, l) => {
      return sum + (l?.addons || []).length;
    }, 0);

    // Match ProductPage totals: base link cost + selected addon costs.
    const total = linkTotal + addonTotal;

    // DA bucket totals are displayed in the same table as `ProductPage.vue`.
    const daTotals = {
      da_20_count: 0,
      da_20_total: 0,
      da_30_count: 0,
      da_30_total: 0,
      da_40_count: 0,
      da_40_total: 0,
      da_50_count: 0,
      da_50_total: 0,
      da_60_count: 0,
      da_60_total: 0,
    };

    normalizedLinks.forEach((l) => {
      const daName = l?.product?.name;
      const base =
        l?.custom_price_check === true
          ? Number(l?.custom_price ?? 0)
          : Number(l?.primary_category?.total_cost ?? 0);

      if (daName === "DA 20 or Below") {
        daTotals.da_20_count += 1;
        daTotals.da_20_total += base;
      } else if (daName === "DA 30+") {
        daTotals.da_30_count += 1;
        daTotals.da_30_total += base;
      } else if (daName === "DA 40+") {
        daTotals.da_40_count += 1;
        daTotals.da_40_total += base;
      } else if (daName === "DA 50+") {
        daTotals.da_50_count += 1;
        daTotals.da_50_total += base;
      } else if (daName === "DA 60+") {
        daTotals.da_60_count += 1;
        daTotals.da_60_total += base;
      }
    });

    localStorage.setItem("order-title", this.form.order_title);
    localStorage.setItem(
      "links",
      LZString.compress(JSON.stringify(normalizedLinks))
    );
    localStorage.setItem("order-total", String(total));
    localStorage.setItem("sub-total", String(total));
    localStorage.setItem("links-total", String(linkTotal));
    localStorage.setItem("addons-count", String(addonCount));
    localStorage.setItem("addons-total", String(addonTotal));
    localStorage.setItem("da_20_count", String(daTotals.da_20_count));
    localStorage.setItem("da_20_total", String(daTotals.da_20_total));
    localStorage.setItem("da_30_count", String(daTotals.da_30_count));
    localStorage.setItem("da_30_total", String(daTotals.da_30_total));
    localStorage.setItem("da_40_count", String(daTotals.da_40_count));
    localStorage.setItem("da_40_total", String(daTotals.da_40_total));
    localStorage.setItem("da_50_count", String(daTotals.da_50_count));
    localStorage.setItem("da_50_total", String(daTotals.da_50_total));
    localStorage.setItem("da_60_count", String(daTotals.da_60_count));
    localStorage.setItem("da_60_total", String(daTotals.da_60_total));
    localStorage.removeItem("discount");
    localStorage.removeItem("couponCode");
    localStorage.removeItem("selected-opportunity");
    localStorage.removeItem("media_link");
    localStorage.removeItem("editedOrder");
    localStorage.removeItem("edited-order-flag");
    this.trackBeginCheckout(normalizedLinks, total);
    this.loaded = false;
    this.$router.push({
      path: "/order-summary",
      query: this.$route.query,
    });
    });
  },
  handleValidationScroll() {
    setTimeout(() => {
      if (this.validation.order_title) {
        const invalidField = document.querySelector(".order-title-error");
        if (invalidField) invalidField.scrollIntoView({ behavior: "smooth" });
      } else {
        const invalidField = document.querySelector(".has-error");
        if (invalidField) invalidField.scrollIntoView({ behavior: "smooth" });
      }
    }, 200);
  },
  isValidURL(url) {
    var isValid = "";
    var match = url.match(/(?:https:\/\/)?(?:www\.)?(.*?)\./);
    const extractedValue = match ? match[1] : "";
    if (/^w+$/.test(extractedValue) && extractedValue.length > 3) {
      isValid = false;
    } else {
      if (/^w+$/.test(extractedValue) && extractedValue.length == 3) {
        const urlPattern =
          /^(?:(?:(?:https?|ftp):\/\/)?(?:www\.)?)?(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))(?:\/(?:[^\s/]*\/)?)?)?(?:\?(?:\S*))?(?:\.(?![^\s.]*$))?$/i;
        isValid = urlPattern.test(url);
      } else {
        const urlPattern =
          /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:(?!www)[/?#]\S*)?$/;
        isValid = urlPattern.test(url);
      }
    }
    return isValid;
  },
  metricProductsFor(metric) {
    const m = (metric || "").toUpperCase();
    if (!m) return [];
    return (this.products || []).filter(
      (p) => typeof p?.name === "string" && p.name.toUpperCase().startsWith(m)
    );
  },
  addLink(val) {
    const id = "_" + Math.random().toString(36).substr(2, 9);
    const newLink = {
      id,
      metric: "DA",
      product: null,
      primary_category: null,
      custom_price_check: false,
      custom_price: 0,
      text: "",
      secondry_category: "",
      url: "",
      addons: [],
      da_fixed_addons: null,
      da_percentage_addons: null,
      traffic_selected_addon: null,
      country_selected_addon: null,
      isDaAddonFixed: true,
      isDaAddonPercentage: true,
      placementType: "guest-post",
      trafficStability6: false,
      trafficStability12: false,
      spamScore5: false,
      spamScore1: false,
      rdldRatio1: false,
      rdldRatio2: false,
      cftfRatio1: false,
      cftfRatio2: false,
      nichePurity: false,
      hyperTargetingExpanded: false,
      total: 0,
      link_notes: "",
    };
    if (val === "clickBtn") {
      newLink.da_fixed_addons = null;
      newLink.da_percentage_addons = null;
      newLink.traffic_selected_addon = null;
      newLink.country_selected_addon = null;
      newLink.addons = [];
      newLink.total = 0;
    }
    this.links.push(newLink);
    this.categories.push([]);
    this.addon_da_options.push([]);

    this.validation.links.push({
      product: false,
      primary_category: false,
      secondry_category: false,
      text: false,
      url: false,
    });
    if (this.links.length <= 50) {
      this.maxRenderedLinks = this.links.length;
    }
  },
  removeLink(index) {
    if (this.links.length <= 1) return;
    this.links.splice(index, 1);
    this.categories.splice(index, 1);
    this.addon_da_options.splice(index, 1);
    this.validation.links.splice(index, 1);
    this.maxRenderedLinks = Math.min(this.maxRenderedLinks, this.links.length || 1);
  },
  toggleHyperTargeting(index) {
    this.links = (this.links || []).map((l, i) => ({
      ...l,
      hyperTargetingExpanded: i === index ? !l.hyperTargetingExpanded : false,
    }));
  },
  onPageScroll() {
    if (this.isScrollTicking) return;
    this.isScrollTicking = true;
    requestAnimationFrame(() => {
      const doc = document.documentElement;
      const scrollBottom = window.scrollY + window.innerHeight;
      const threshold = doc.scrollHeight - 500;
      if (scrollBottom >= threshold && this.maxRenderedLinks < this.links.length) {
        this.maxRenderedLinks = Math.min(this.maxRenderedLinks + 40, this.links.length);
      }
      this.isScrollTicking = false;
    });
  },
  copyLink(index) {
    const link = this.links[index];
    if (!link) return;
    const copy = JSON.parse(JSON.stringify(link));
    copy.id = "_" + Math.random().toString(36).substr(2, 9);
    this.links.splice(index + 1, 0, copy);
    this.categories.splice(index + 1, 0, this.categories[index] || []);
    this.addon_da_options.splice(index + 1, 0, this.addon_da_options[index] || []);
    this.validation.links.splice(index + 1, 0, {
      product: false,
      primary_category: false,
      secondry_category: false,
      text: false,
      url: false,
    });
  },
  resetAddonSelections(index) {
    const link = this.links[index];
    if (!link) return;

    link.da_fixed_addons = null;
    link.da_percentage_addons = null;
  link.traffic_selected_addon = null;
  link.country_selected_addon = null;
  link.addons = [];
    link.nichePurity = false;
    link.trafficStability6 = false;
    link.trafficStability12 = false;
    link.spamScore5 = false;
    link.spamScore1 = false;
    link.rdldRatio1 = false;
    link.rdldRatio2 = false;
    link.cftfRatio1 = false;
    link.cftfRatio2 = false;
  },
  setMetric(index, metric) {
    const link = this.links[index];
    if (!link) return;
    if (this.isLinkLockedByCustomPrice(link)) return;
    if (link.metric === metric) return;

    link.metric = metric;
    link.product = null;
    link.primary_category = null;
    this.categories[index] = [];
    this.addon_da_options[index] = [];
    this.resetAddonSelections(index);
    this.syncAddonsWithBooleans(index);

    this.updateLinkTotal(index);
  },
  onProductChange(index, selectedProduct) {
    const link = this.links[index];
    if (this.isLinkLockedByCustomPrice(link)) return;
    const prevIndustryId = link?.primary_category?.id ?? null;
    link.product = selectedProduct || null;
    link.custom_price_check = false;

    // DA/DR Value selection: reset addons only (keep selected industry).
    if (link.product) {
      this.resetAddonSelections(index);
    }

    if (!link.product) {
      this.categories[index] = [];
      link.primary_category = null;
      this.addon_da_options[index] = [];
      this.resetAddonSelections(index);
      this.syncAddonsWithBooleans(index);
      this.updateLinkTotal(index);
      return;
    }

    this.categories[index] = this.getPrimaryCategories(link.product);
    if (prevIndustryId) {
      // Keep same industry if it exists for this DA/DR (with refreshed pricing).
      // Otherwise clear it — stale selection would keep old cost in total and skip required validation.
      const matched = this.categories[index].find(
        (c) => Number(c.id) === Number(prevIndustryId)
      );
      link.primary_category = matched || null;
    } else {
      link.primary_category = null;
    }
    this.refreshAddonCosts(index);

    // Refresh DA options and recalculate totals.
    this.addon_da_options[index] = this.getAddonDaOption(index);
    this.syncAddonsWithBooleans(index);

    this.updateLinkTotal(index);
  },
  onCategoryChange(index, selectedCategory) {
    const link = this.links[index];
    if (this.isLinkLockedByCustomPrice(link)) return;

    link.primary_category = selectedCategory || null;
    link.custom_price_check = false;
    this.addon_da_options[index] = this.getAddonDaOption(index);
    this.resetAddonSelections(index);
    // Keep defaults (spam score / ratios) in sync with checkboxes.
    this.syncAddonsWithBooleans(index);

    this.updateLinkTotal(index);
  },
  hasSelectedTrafficAddon(link) {
    if (!link?.traffic_selected_addon || link.traffic_selected_addon === "null") {
      return false;
    }
    try {
      const selected = JSON.parse(link.traffic_selected_addon);
      return !!(selected && selected.id != null);
    } catch {
      return false;
    }
  },
  setNichePurity(index, value) {
    const link = this.links[index];
    if (!link) return;
    if (value && this.isPureNicheDisabledForCountry(link)) return;
    // Minimum Traffic must be deselected first — Stability is independent.
    if (value && this.hasSelectedTrafficAddon(link)) return;
    link.nichePurity = !!value;

    const nicheOpt = this.getNichePurityOption(index);
    if (!nicheOpt) {
      // No option found from backend; just maintain state.
      this.updateLinkTotal(index);
      return;
    }

    const exists = (link.addons || []).some((a) => a?.id === nicheOpt.id);
    if (link.nichePurity) {
      if (!exists && this.isAddonCostPositive(nicheOpt)) {
        link.addons = [...(link.addons || []), nicheOpt];
      }
    } else {
      link.addons = (link.addons || []).filter((a) => a?.id !== nicheOpt.id);
    }

    this.updateLinkTotal(index);
  },
  getNichePurityOption(index) {
    const link = this.links[index];
    if (!link?.primary_category || !link?.product) return null;

    const addon = (this.addon_products || []).find((pd) => {
      const name = String(pd?.name || "").toLowerCase();
      return name.includes("niche purity") && pd?.dependent_da === "no";
    });
    if (!addon?.options?.length) return null;

    const opt =
      addon.options.find((o) =>
        String(o?.name || "").toLowerCase().includes("niche purity")
      ) || addon.options[0];

    // Niche Purity percentage is calculated on Industry/Category cost only.
    const baseCost = this.getLinkBaseCostForAddons(link);

    const priceType = opt?.addons_data?.price_type || addon?.price_type;
    const price = Number(opt?.price) || 0;

    let cost = 0;
    if (priceType === "percentage") {
      cost = baseCost * (price / 100);
    } else {
      cost = price;
    }

    if (!cost) return null;

    return {
      id: opt.id,
      addon_id: opt.addon_id,
      addon_name: addon.name,
      name: opt.name,
      cost,
      type: addon.type,
      price_type: opt?.addons_data?.price_type || addon.price_type,
      dependent_da: addon.dependent_da,
      product_id: link.product?.id,
      category_id: link.primary_category?.id,
    };
  },
  getNichePurityCost(index) {
    const link = this.links[index];
    if (this.isLinkLockedByCustomPrice(link)) return 0;
    const opt = this.getNichePurityOption(index);
    return opt?.cost || 0;
  },

  daAddonOptionsByAddonName(index, addonName) {
    const n = String(addonName || "").toLowerCase();
    const link = this.links[index];
    const addon = (this.addon_products || []).find((pd) => {
      return (
        String(pd?.name || "").toLowerCase().trim() === n &&
        pd?.dependent_da === "yes" &&
        pd?.type === "multiple"
      );
    });
    if (!addon?.options?.length) return [];

    // DA dependent addons: cost is based on selected category + product costs.
    // When selection is not made yet, base cost becomes 0 so options still render.
    // For percentage DA-dependent addons, pricing in this page is calculated
    // on the selected Industry/Category cost only (same as traffic logic).
    const baseCost = this.getLinkBaseCostForAddons(link);
    const productId = link?.product?.id;

    return addon.options
      .map((opt) => {
        const addonsData = opt?.addons_data || {};
        if (addonsData?.dependent_da !== "yes") return null;

        const priceType = addonsData?.price_type;
        // For DA-dependent addons, backend uses options_product cost as percentage/fixed driver.
        const driver =
          (opt?.options_product || []).find((p) => p?.product_id === productId)?.cost ??
          0;
        const driverVal = Number(driver) || 0;

        let cost = 0;
        if (priceType === "percentage") {
          cost = baseCost * (driverVal / 100);
        } else if (priceType === "fixed") {
          cost = driverVal;
        }

        return {
          id: opt.id,
          addon_id: opt.addon_id,
          addon_name: addon.name,
          name: opt.name,
          cost: this.resolveAddonCostForLink(link, cost),
          type: addon.type,
          price_type: addonsData.price_type,
          dependent_da: addon.dependent_da,
          product_id: productId || null,
          category_id: link?.primary_category?.id || null,
        };
      })
      .filter(Boolean);
  },
  getTrafficStabilityBoolKey(opt) {
    const name = String(opt?.name || "").toLowerCase();
    if (name.includes("6 month")) return "trafficStability6";
    if (name.includes("12 month")) return "trafficStability12";
    return null;
  },
  getSpamScoreBoolKey(opt) {
    const name = String(opt?.name || "").toLowerCase();
    if (name.includes("5%")) return "spamScore5";
    if (name.includes("1%")) return "spamScore1";
    return null;
  },
  getRdldRatioBoolKey(opt) {
    const name = String(opt?.name || "").toLowerCase();
    if (name.includes("1:1")) return "rdldRatio1";
    if (name.includes("2:1")) return "rdldRatio2";
    return null;
  },
  getCftfRatioBoolKey(opt) {
    const name = String(opt?.name || "").toLowerCase();
    if (name.includes("1:1")) return "cftfRatio1";
    if (name.includes("2:1")) return "cftfRatio2";
    return null;
  },
  nonDaMultipleAddonOptionsByAddonName(index, addonName) {
    const link = this.links[index];
    const addon = (this.addon_products || []).find((pd) => {
      const name = String(pd?.name || "").toLowerCase();
      return (
        name === String(addonName || "").toLowerCase() &&
        pd?.dependent_da === "no" &&
        pd?.type === "multiple"
      );
    });
    if (!addon?.options?.length) return [];

    // Non-DA dependent addons: percentage addons should be calculated
    // on the selected Industry/Category cost only (not DA/DR product cost).
    // When selection is not made yet, cost defaults to 0 but options still render.
    const categoryCost = this.getLinkBaseCostForAddons(link);

    return addon.options
      .filter((opt) => this.isCatalogAddonOptionAvailable(opt))
      .map((opt) => {
        const addonsData = opt?.addons_data || {};
        if (addonsData?.dependent_da !== "no") return null;

        const priceType = addonsData?.price_type;
        const price = Number(opt?.price) || 0;
        if (!priceType) return null;

        // Keep existing exclude rule for "100000" option if present.
        if (String(opt?.name || "").trim() === "100000") return null;

        let cost = 0;
        if (priceType === "percentage") {
          cost = categoryCost * (price / 100);
        } else if (priceType === "fixed") {
          cost = price;
        }

        return {
          id: opt.id,
          addon_id: opt.addon_id,
          addon_name: addon.name,
          name: opt.name,
          cost: this.resolveAddonCostForLink(link, cost),
          type: addon.type,
          price_type: priceType,
          dependent_da: addon.dependent_da,
          product_id: link?.product?.id || null,
          category_id: link?.primary_category?.id || null,
          active: opt.active ?? opt.is_active,
          delete: opt.delete ?? opt.deleted ?? opt.is_deleted,
        };
      })
      .filter(Boolean);
  },
  onToggleAddonOption(index, option, boolKey, checked) {
    const link = this.links[index];
    if (!link || !option) return;

    const addonName = this.norm(option?.addon_name);

    const isRdld = addonName.includes("rd:ld ratio");
    const isCftf = addonName.includes("cf:tf ratio");

    const clearGroupBooleans = () => {
      if (addonName.includes("traffic stability")) {
        link.trafficStability6 = false;
        link.trafficStability12 = false;
      } else if (addonName.includes("spam score")) {
        link.spamScore5 = false;
        link.spamScore1 = false;
      } else if (isRdld) {
        link.rdldRatio1 = false;
        link.rdldRatio2 = false;
      } else if (isCftf) {
        link.cftfRatio1 = false;
        link.cftfRatio2 = false;
      }
    };

    // RD/LD and CF/TF are mutually exclusive — only one ratio addon per link.
    if (checked && isRdld) {
      this.clearCftfRatioAddon(index);
    } else if (checked && isCftf) {
      this.clearRdldRatioAddon(index);
    }

    if (boolKey) {
      if (checked) {
        clearGroupBooleans();
      }
      link[boolKey] = checked;
    }

    const existingAddons = link.addons || [];
    const exists = existingAddons.some((a) => a?.id === option.id);
    if (checked) {
      // Enforce single option per addon group (radio-like behavior).
      link.addons = existingAddons.filter(
        (a) => this.norm(a?.addon_name) !== addonName
      );
      if (!exists && this.isAddonCostPositive(option)) {
        link.addons = [...(link.addons || []), option];
      }
    } else {
      link.addons = (link.addons || []).filter((a) => a?.id !== option.id);
    }

    this.updateLinkTotal(index);
  },
  clearRdldRatioAddon(index) {
    const link = this.links[index];
    if (!link) return;
    link.rdldRatio1 = false;
    link.rdldRatio2 = false;
    link.addons = (link.addons || []).filter(
      (a) => !this.norm(a?.addon_name).includes("rd:ld ratio")
    );
  },
  clearCftfRatioAddon(index) {
    const link = this.links[index];
    if (!link) return;
    link.cftfRatio1 = false;
    link.cftfRatio2 = false;
    link.addons = (link.addons || []).filter(
      (a) => !this.norm(a?.addon_name).includes("cf:tf ratio")
    );
  },
  hasRdldRatioSelected(link) {
    return !!(link?.rdldRatio1 || link?.rdldRatio2);
  },
  hasCftfRatioSelected(link) {
    return !!(link?.cftfRatio1 || link?.cftfRatio2);
  },
  enforceRatioAddonMutualExclusion(index) {
    const link = this.links[index];
    if (!link) return;

    const hasRdld = this.hasRdldRatioSelected(link);
    const hasCftf = this.hasCftfRatioSelected(link);
    if (!(hasRdld && hasCftf)) return;

    // Conflict (e.g. draft/upload): keep RD/LD, clear CF/TF.
    this.clearCftfRatioAddon(index);
  },
  syncAddonsWithBooleans(index) {
    const link = this.links[index];
    if (!link) return;

    // Traffic Stability (DA dependent)
    const daTrafficOpts = this.daAddonOptionsByAddonName(index, "Traffic Stability");
    const addIf = (boolKey, matcher) => {
      if (!link[boolKey]) return;
      const opt = daTrafficOpts.find((o) => matcher(String(o?.name || "")));
      if (opt && this.isAddonCostPositive(opt)) {
        link.addons = [...(link.addons || []), opt];
      }
    };
    addIf("trafficStability6", (n) => n.toLowerCase().includes("6 month"));
    addIf("trafficStability12", (n) => n.toLowerCase().includes("12 month"));

    // Spam Score (Non-DA dependent, percentage)
    const spamOpts = this.nonDaMultipleAddonOptionsByAddonName(index, "Spam Score");
    const addSpam = (boolKey, matcher) => {
      if (!link[boolKey]) return;
      const opt = spamOpts.find((o) => matcher(String(o?.name || "")));
      if (opt && this.isAddonCostPositive(opt)) {
        link.addons = [...(link.addons || []), opt];
      }
    };
    addSpam("spamScore5", (n) => n.toLowerCase().includes("5%"));
    addSpam("spamScore1", (n) => n.toLowerCase().includes("1%"));

    // RD:LD Ratio
    const rdOpts = this.nonDaMultipleAddonOptionsByAddonName(index, "RD:LD Ratio");
    const addRd = (boolKey, matcher) => {
      if (!link[boolKey]) return;
      const opt = rdOpts.find((o) => matcher(String(o?.name || "")));
      if (opt && this.isAddonCostPositive(opt)) {
        link.addons = [...(link.addons || []), opt];
      }
    };
    addRd("rdldRatio1", (n) => n.toLowerCase().includes("1:1"));
    addRd("rdldRatio2", (n) => n.toLowerCase().includes("2:1"));

    // CF:TF Ratio
    const cfOpts = this.nonDaMultipleAddonOptionsByAddonName(index, "CF:TF Ratio");
    const addCf = (boolKey, matcher) => {
      if (!link[boolKey]) return;
      const opt = cfOpts.find((o) => matcher(String(o?.name || "")));
      if (opt && this.isAddonCostPositive(opt)) {
        link.addons = [...(link.addons || []), opt];
      }
    };
    addCf("cftfRatio1", (n) => n.toLowerCase().includes("1:1"));
    addCf("cftfRatio2", (n) => n.toLowerCase().includes("2:1"));
  },
  getContentApprovalAddonProduct() {
    return (this.addon_products || []).find((pd) => {
      const name = String(pd?.name || "").toLowerCase().trim();
      return (
        (name === "content approval" || name.includes("content approval")) &&
        pd?.type === "single" &&
        pd?.dependent_da === "no"
      );
    }) || null;
  },
  contentApprovalOptions(index = null) {
    const currentLink = index == null ? null : this.links[index] || null;
    const addon = this.getContentApprovalAddonProduct();
    if (!addon?.options?.length) return [];

    // Match ProductPage: non-DA dependent addons come from addon_products.options
    return addon.options
      .map((opt) => {
        const addonsData = opt?.addons_data || {};
        if (addonsData?.dependent_da !== "no") return null;
        if (addonsData?.price_type !== "fixed") return null; // requested: single fixed addon
        if (String(opt?.name || "").trim() === "100000") return null;

        const optPrice = Number(opt?.price) || 0;

        const cost = optPrice;

        return {
          id: opt.id,
          addon_id: opt.addon_id,
          type: addonsData.type,
          price_type: addonsData.price_type,
          dependent_da: addonsData.dependent_da,
          addon_name: addonsData.name,
          name: opt.name,
          cost: this.resolveAddonCostForLink(currentLink, cost),
          product_id: null,
          category_id: null,
        };
      })
      .filter(Boolean);
  },
  isContentApprovalSelected(index, option) {
    const link = this.links[index];
    if (!link?.addons?.length) return false;
    return link.addons.some((a) => a?.id === option.id);
  },
  setContentApprovalSelected(index, checked, option) {
    const link = this.links[index];
    if (!link) return;
    if (!this.isBaseSelected(link)) return;

    const addonName = this.norm(option?.addon_name);
    const existingAddons = link.addons || [];
    const exists = existingAddons.some((a) => a?.id === option.id);
    if (checked) {
      // Keep only one Content Approval option selected at a time.
      link.addons = existingAddons.filter(
        (a) => this.norm(a?.addon_name) !== addonName
      );
      if (!exists && this.isAddonCostPositive(option)) {
        link.addons = [...(link.addons || []), option];
      }
    } else {
      link.addons = (link.addons || []).filter((a) => a?.id !== option.id);
    }

    this.updateLinkTotal(index);
  },
  countryAddonOptions(index) {
    const link = this.links[index];
    const ids = new Set((this.countryAddonProducts || []).map((pd) => pd.id));
    const rows = this.addon_da_options[index] || [];
    let options = [];
    if (ids.size) {
      options = rows
        .filter((o) => ids.has(o.addon_id))
        .map((o) => ({ ...o, cost: this.resolveAddonCostForLink(link, o?.cost) }));
    } else {
      options = rows
        .filter((o) => this.norm(o?.addon_name) === "country")
        .map((o) => ({ ...o, cost: this.resolveAddonCostForLink(link, o?.cost) }));
    }

    // Keep selected country option visible even if current dynamic list
    // doesn't include it (e.g. cost recalculated to zero under custom price).
    if (link?.country_selected_addon && link.country_selected_addon !== "null") {
      try {
        const selected = JSON.parse(link.country_selected_addon);
        const exists = options.some((o) => Number(o?.id) === Number(selected?.id));
        if (!exists && selected?.id != null) {
          options = [
            ...options,
            { ...selected, cost: this.resolveAddonCostForLink(link, selected?.cost) },
          ];
        }
      } catch {
        // ignore malformed stored JSON
      }
    }

    return options;
  },
  selectedCountryCost(index) {
    const link = this.links[index];
    if (this.isLinkLockedByCustomPrice(link)) return 0;
    if (!link?.country_selected_addon || link.country_selected_addon === "null") return 0;
    try {
      return Number(JSON.parse(link.country_selected_addon)?.cost) || 0;
    } catch {
      return 0;
    }
  },
  onCountrySelect(index, selectedJson) {
    const link = this.links[index];
    if (!link) return;

    const countryAddonIds = new Set((this.countryAddonProducts || []).map((pd) => pd.id));
    const stripCountryAddons = (addons) =>
      (addons || []).filter((a) => {
        if (countryAddonIds.size) return !countryAddonIds.has(a.addon_id);
        return this.norm(a?.addon_name) !== "country";
      });

    link.addons = stripCountryAddons(link.addons);
    link.country_selected_addon = selectedJson;

    let selected = null;
    try {
      selected =
        selectedJson && selectedJson !== "null" && String(selectedJson) !== "null"
          ? JSON.parse(selectedJson)
          : null;
    } catch {
      selected = null;
    }

    if (!selected) {
      const clearSlot = (key) => {
        if (!link[key]) return;
        try {
          const p = JSON.parse(link[key]);
          const isCountry =
            (countryAddonIds.size && countryAddonIds.has(p?.addon_id)) ||
            (!countryAddonIds.size && this.norm(p?.addon_name) === "country");
          if (isCountry) link[key] = null;
        } catch {
          /* ignore */
        }
      };
      clearSlot("da_fixed_addons");
      clearSlot("da_percentage_addons");
      this.updateLinkTotal(index);
      return;
    }

    if (selected?.price_type === "percentage") {
      link.da_percentage_addons = selectedJson;
    } else {
      link.da_fixed_addons = selectedJson;
    }

    this.setSelectedMAddon(selected.addon_id, index, selectedJson);
    this.enforceCountryAddonRestrictions(index);
    this.updateLinkTotal(index);
  },
  trafficAddonOptions(index, opts = {}) {
    const bypassCountryLimit = !!opts?.bypassCountryLimit;
    const addonIds = new Set((this.trafficAddonProducts || []).map((pd) => pd.id));
    const link = this.links[index];
    if (!addonIds.size) return [];
    const options = (this.addon_da_options[index] || [])
      .filter((o) => addonIds.has(o.addon_id))
      .filter((o) => !this.isTrafficOptionZero(o))
      .filter((o) => this.isAddonCostPositive(o, link));
    let filteredOptions = options;
    if (!bypassCountryLimit && this.isCountryTrafficLimitedToFiveK(link)) {
      if (options.some((o) => this.isTrafficOptionFiveK(o))) {
        filteredOptions = options.filter((o) => this.isTrafficOptionAtOrBelowFiveK(o));
      } else {
        filteredOptions = options;
      }
    }
    const normalizedOptions = filteredOptions.map((o) => ({
      ...o,
      cost: this.resolveAddonCostForLink(link, o?.cost),
    }));

    // Keep selected traffic option visible even if dynamic options are currently
    // empty (e.g. custom price lock makes addon costs zero/disabled).
    if (link?.traffic_selected_addon && link.traffic_selected_addon !== "null") {
      try {
        const selected = JSON.parse(link.traffic_selected_addon);
        const exists = normalizedOptions.some(
          (o) => Number(o?.id) === Number(selected?.id)
        );
        const canKeepSelectedForDisplay =
          this.isLinkLockedByCustomPrice(link) ||
          this.isAddonCostPositive(selected, link);
        if (
          !exists &&
          selected?.id != null &&
          !this.isTrafficOptionZero(selected) &&
          canKeepSelectedForDisplay
        ) {
          normalizedOptions.push({
            ...selected,
            cost: this.resolveAddonCostForLink(link, selected?.cost),
          });
        }
      } catch {
        // ignore malformed stored JSON
      }
    }

    return normalizedOptions;
  },
  selectedTrafficCost(index) {
    const link = this.links[index];
    if (this.isLinkLockedByCustomPrice(link)) return 0;
    if (!link?.traffic_selected_addon || link.traffic_selected_addon === "null") return 0;
    try {
      return Number(JSON.parse(link.traffic_selected_addon)?.cost) || 0;
    } catch {
      return 0;
    }
  },
  /** Default Traffic dropdown label when no paid option is selected: copy + ($0.00), driven by selected DA/DR product. */
  trafficDefaultOptionText(link) {
    const raw = String(link?.product?.name || "").trim();
    if (!raw) {
      return "No minimum traffic";
    }
    const p = raw.replace(/\s+/g, " ");
    if (/60\s*\+/i.test(p)) {
      return "Min 1000 monthly";
    }
    if (/50\s*\+/i.test(p)) {
      return "Min 800 monthly";
    }
    if (/40\s*\+/i.test(p)) {
      return "Min 500 monthly";
    }
    if (/30\s*\+/i.test(p)) {
      return "Min 200 monthly";
    }
    if (/20\s+or\s+below/i.test(p)) {
      return "No minimum traffic";
    }
    if (/20\s*\+/i.test(p)) {
      return "Min 100 monthly";
    }
    return "No minimum traffic";
  },
  onTrafficSelect(index, selectedJson) {
    const link = this.links[index];
    if (!link) return;

    // Selecting Traffic turns Niche Purity off; Stability remains untouched.
    if (
      selectedJson &&
      selectedJson !== "null" &&
      link.nichePurity
    ) {
      this.setNichePurity(index, false);
    }

    const trafficAddonIds = new Set((this.trafficAddonProducts || []).map((pd) => pd.id));

    // Remove previously selected traffic addons so switching option never stacks.
    link.addons = (link.addons || []).filter((a) => !trafficAddonIds.has(a.addon_id));

    link.traffic_selected_addon = selectedJson;

    let selected = null;
    try {
      selected = JSON.parse(selectedJson);
    } catch {
      selected = null;
    }

    if (!selected) {
      const clearSlot = (key) => {
        if (!link[key]) return;
        try {
          const p = JSON.parse(link[key]);
          if (trafficAddonIds.has(p?.addon_id)) link[key] = null;
        } catch {
          /* ignore */
        }
      };
      clearSlot("da_fixed_addons");
      clearSlot("da_percentage_addons");
      this.updateLinkTotal(index);
      return;
    }

    if (selected?.price_type === "percentage") {
      link.da_percentage_addons = selectedJson;
    } else {
      link.da_fixed_addons = selectedJson;
    }

    this.setSelectedMAddon(selected.addon_id, index, selectedJson);
    this.updateLinkTotal(index);
  },
  syncSelectedAddonDropdowns(index) {
    const link = this.links[index];
    if (!link) return;

    const syncOne = (fieldName, options) => {
      const raw = link[fieldName];
      if (!raw || raw === "null") return;
      let parsed = null;
      try {
        parsed = JSON.parse(raw);
      } catch {
        return;
      }
      const matched = (options || []).find((o) => Number(o?.id) === Number(parsed?.id));
      if (matched) {
        link[fieldName] = JSON.stringify(matched);
      }
    };

    syncOne("traffic_selected_addon", this.trafficAddonOptions(index, { bypassCountryLimit: true }));
    syncOne("country_selected_addon", this.countryAddonOptions(index));
  },
  refreshAddonCosts(index) {
    const link = this.links[index];
    if (!link) return;

    const optionById = new Map();

    // DA-dependent options (traffic + UK TLD etc.)
    (this.addon_da_options[index] || []).forEach((o) => {
      if (o?.id != null) optionById.set(o.id, o);
    });

    // DA-dependent multiple checkboxes.
    this.daAddonOptionsByAddonName(index, "Traffic Stability").forEach((o) => {
      if (o?.id != null) optionById.set(o.id, o);
    });

    // Non-DA multiple checkboxes.
    [
      ...this.nonDaMultipleAddonOptionsByAddonName(index, "Spam Score"),
      ...this.nonDaMultipleAddonOptionsByAddonName(index, "RD:LD Ratio"),
      ...this.nonDaMultipleAddonOptionsByAddonName(index, "CF:TF Ratio"),
    ].forEach((o) => {
      if (o?.id != null) optionById.set(o.id, o);
    });

    // Single add-ons.
    const contentOpt = this.contentApprovalOptions(index);
    contentOpt.forEach((o) => optionById.set(o.id, o));

    const np = this.getNichePurityOption(index);
    if (np?.id != null) optionById.set(np.id, np);

    // Keep only addons that still exist in the active catalog.
    this.pruneUnavailableLinkAddons(index);

    link.addons = (link.addons || []).map((a) => {
      const upd = optionById.get(a?.id);
      return upd ? { ...a, ...upd } : a;
    });
    this.syncSelectedAddonDropdowns(index);
  },
  isBaseSelected(link) {
    return !!(link?.product && link?.primary_category);
  },
  isAddonOptionDisabled(link, opt) {
    return (
      this.isLinkLockedByCustomPrice(link) ||
      !this.isBaseSelected(link) ||
      !this.isAddonCostPositive(opt)
    );
  },
  isTrafficSelectDisabled(link) {
    return (
      !link?.primary_category ||
      this.isLinkLockedByCustomPrice(link) ||
      !!link?.nichePurity
    );
  },
  isCountrySelectDisabled(link) {
    return !link?.primary_category || this.isLinkLockedByCustomPrice(link);
  },
  isPureNicheToggleDisabled(link) {
    return (
      !this.isBaseSelected(link) ||
      this.isLinkLockedByCustomPrice(link) ||
      this.isPureNicheDisabledForCountry(link) ||
      this.hasSelectedTrafficAddon(link)
    );
  },
  trafficConflictTitle(link) {
    if (!this.isBaseSelected(link) || !link?.nichePurity) return "";
    return this.tooltips.trafficDisabledByNiche;
  },
  nicheConflictTitle(link) {
    if (!this.isBaseSelected(link) || !this.hasSelectedTrafficAddon(link)) {
      return "";
    }
    return this.tooltips.nicheDisabledByTraffic;
  },
  rdldConflictTitle(link) {
    if (!this.isBaseSelected(link) || !this.hasCftfRatioSelected(link)) {
      return "";
    }
    return this.tooltips.rdldDisabledByCftf;
  },
  cftfConflictTitle(link) {
    if (!this.isBaseSelected(link) || !this.hasRdldRatioSelected(link)) {
      return "";
    }
    return this.tooltips.cftfDisabledByRdld;
  },
  updateLinkTotal(index) {
    const link = this.links[index];
    if (!link) return;
    const base = link?.custom_price_check
      ? Number(link?.custom_price ?? 0) || 0
      : Number(link?.primary_category?.cost) || 0;
    const addonsTotal = this.isLinkLockedByCustomPrice(link)
      ? 0
      : (link.addons || []).reduce((sum, a) => sum + (Number(a?.cost) || 0), 0);
    link.total = base + addonsTotal;
  },
  getAddonDaOption(index) {
    const link = this.links[index];
    if (!link?.product || !link?.primary_category) return [];

    const category_id = link.primary_category.id;
    const product_id = link.product.id;
    const addon_da_options = [];
    link.isDaAddonPercentage = true;
    link.isDaAddonFixed = true;
    // Percentage addons should be calculated on the current link base cost.
    const link_base_cost = this.getLinkBaseCostForAddons(link);

    (link.product.addons || []).forEach((opt) => {
      if (
        opt?.addons_data?.price_type === "percentage" &&
        opt?.addons_data?.dependent_da === "yes"
      ) {
        const addon_percentage = link_base_cost * ((Number(opt?.pivot?.cost) || 0) / 100);
        link.isDaAddonPercentage = false;
        addon_da_options.push({
          id: opt.id,
          addon_id: opt.addon_id,
          type: opt.addons_data.type,
          price_type: opt.addons_data.price_type,
          dependent_da: opt.addons_data.dependent_da,
          addon_name: opt.addons_data.name,
          name: opt.name,
          cost: this.resolveAddonCostForLink(link, addon_percentage),
          product_id,
          category_id,
        });
      }

      if (
        opt?.addons_data?.price_type === "fixed" &&
        opt?.addons_data?.dependent_da === "yes" &&
        opt?.name !== "100000"
      ) {
        const addon_fixed = Number(opt?.pivot?.cost) || 0;
        if (addon_fixed !== 0) {
          link.isDaAddonFixed = false;
          addon_da_options.push({
            id: opt.id,
            addon_id: opt.addon_id,
            type: opt.addons_data.type,
            price_type: opt.addons_data.price_type,
            dependent_da: opt.addons_data.dependent_da,
            addon_name: opt.addons_data.name,
            name: opt.name,
            cost: this.resolveAddonCostForLink(link, addon_fixed),
            product_id,
            category_id,
          });
        }
      }
    });

    return addon_da_options;
  },
  setSelectedMAddon(id, key, index) {
    var addon_id = id;
    var MultiAddon = JSON.parse(index);
    if (MultiAddon != null) {
      let NewMAddon = this.links[key].addons.filter((o) => {
        return o.addon_id != MultiAddon.addon_id;
      });

      if (MultiAddon.addon_name.toLowerCase().includes("minimum traffic")) {
        const ukTldIndex = NewMAddon.findIndex(
          (a) =>
            String(a?.name || "").toLowerCase().includes("uk tld") ||
            String(a?.addon_name || "").toLowerCase().includes("uk tld")
        );
        if (ukTldIndex !== -1) {
          NewMAddon.splice(ukTldIndex, 1);
          toast.error(this.trafficTLDMessage, {
            timeout: 3000,
          });
        }
      }

      this.links[key].addons = NewMAddon;
      if (this.isAddonCostPositive(MultiAddon)) {
        this.links[key].addons.push(MultiAddon);
      }
    } else {
      var delete_addon = this.links[key].addons.findIndex(
        (item) => item.addon_id === addon_id
      );
      if (delete_addon !== -1) {
        this.links[key].addons.splice(delete_addon, 1);
      }
    }
  },
  findProductByName(name) {
    const needle = String(name || "").trim().toLowerCase();
    if (!needle) return null;
    return (this.products || []).find(
      (p) => String(p?.name || "").trim().toLowerCase() === needle
    ) || null;
  },
  normalizeCategoryLabel(value) {
    return String(value || "")
      .toLowerCase()
      .replace(/&/g, " and ")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  },
  resolveMigratedCategoryName(name) {
    const normalizedInput = this.normalizeCategoryLabel(name);
    if (!normalizedInput) return String(name || "");
    const migration = (this.categoryMigrationPairs || []).find(
      (pair) => this.normalizeCategoryLabel(pair?.old) === normalizedInput
    );
    return migration?.new || String(name || "");
  },
  findCategoryByName(index, name) {
    const raw = String(name || "").trim();
    if (!raw) return null;
    const needle = this.normalizeCategoryLabel(raw);
    const migratedNeedle = this.normalizeCategoryLabel(this.resolveMigratedCategoryName(raw));
    return (this.categories[index] || []).find(
      (c) => {
        const categoryName = this.normalizeCategoryLabel(c?.name);
        return categoryName === needle || categoryName === migratedNeedle;
      }
    ) || null;
  },
  normalizedCsvCellValue(v) {
    return String(v ?? "").trim();
  },
  normalizedCsvLookupKey(v) {
    return String(v ?? "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  },
  getUploadedRowValue(row, aliases = []) {
    const aliasSet = new Set(
      aliases.map((a) => this.normalizedCsvLookupKey(a)).filter(Boolean)
    );
    for (const key of Object.keys(row || {})) {
      if (aliasSet.has(this.normalizedCsvLookupKey(key))) {
        return row[key];
      }
    }
    return "";
  },
  isTruthyUploadValue(v) {
    const value = this.normalizedCsvCellValue(v).toLowerCase();
    return ["yes", "y", "true", "1", "on", "checked", "enabled"].includes(value);
  },
  isFalsyUploadValue(v) {
    const value = this.normalizedCsvCellValue(v).toLowerCase();
    return ["no", "n", "false", "0", "off", "disabled"].includes(value);
  },
  findAddonOptionFromUploadValue(options = [], rawValue) {
    const value = this.normalizedCsvCellValue(rawValue);
    if (!value || /^n\/?a$/i.test(value) || /^null$/i.test(value)) return null;

    const valueNorm = this.normalizedCsvLookupKey(value);
    // Strict matching: keep upload behavior aligned with configured addon values.
    // If uploaded value differs from known option labels, we leave addon unselected.
    return (
      options.find((opt) => this.normalizedCsvLookupKey(opt?.name) === valueNorm) ||
      null
    );
  },
  applyUploadedAddonsFromRow(row, index) {
    const link = this.links[index];
    if (!link || !this.isBaseSelected(link)) return;

    this.resetAddonSelections(index);
    this.addon_da_options[index] = this.getAddonDaOption(index);

    const countryValue = this.getUploadedRowValue(row, ["Country"]);
    const countryOpt = this.findAddonOptionFromUploadValue(
      this.countryAddonOptions(index),
      countryValue
    );
    if (countryOpt && !this.isAddonOptionDisabled(link, countryOpt)) {
      this.onCountrySelect(index, JSON.stringify(countryOpt));
    }

    const trafficValue = this.getUploadedRowValue(row, [
      "Minimum Traffic",
      "Minimum Organic Traffic",
      "Traffic",
    ]);
    const trafficOpt = this.findAddonOptionFromUploadValue(
      this.trafficAddonOptions(index),
      trafficValue
    );
    if (trafficOpt && !this.isAddonOptionDisabled(link, trafficOpt)) {
      this.onTrafficSelect(index, JSON.stringify(trafficOpt));
    }

    const toggleSingle = (options, rawValue, keyGetter) => {
      const opt = this.findAddonOptionFromUploadValue(options, rawValue);
      if (!opt) return;
      if (this.isAddonOptionDisabled(link, opt)) return;
      const boolKey = keyGetter.call(this, opt);
      this.onToggleAddonOption(index, opt, boolKey, true);
    };

    const trafficStabilityValue = this.getUploadedRowValue(row, [
      "Stable Traffic Graph",
      "Traffic Stability",
    ]);
    toggleSingle(
      this.daAddonOptionsByAddonName(index, "Traffic Stability"),
      trafficStabilityValue,
      this.getTrafficStabilityBoolKey
    );

    const spamValue = this.getUploadedRowValue(row, ["Spam Score"]);
    toggleSingle(
      this.nonDaMultipleAddonOptionsByAddonName(index, "Spam Score"),
      spamValue,
      this.getSpamScoreBoolKey
    );

    const reviewValue = this.getUploadedRowValue(row, [
      "Review",
      "Content Approval",
    ]);
    const reviewOptions = this.contentApprovalOptions(index);
    const reviewOpt = this.findAddonOptionFromUploadValue(reviewOptions, reviewValue);
    if (reviewOpt && !this.isAddonOptionDisabled(link, reviewOpt)) {
      this.setContentApprovalSelected(index, true, reviewOpt);
    } else {
      const reviewNorm = this.normalizedCsvLookupKey(reviewValue);
      const wantsReview =
        this.isTruthyUploadValue(reviewValue) ||
        reviewNorm === "review" ||
        reviewNorm === "content approval";
      if (wantsReview && reviewOptions.length === 1) {
        const fallbackReview = reviewOptions[0];
        if (!this.isAddonOptionDisabled(link, fallbackReview)) {
          this.setContentApprovalSelected(index, true, fallbackReview);
        }
      }
    }

    const rdldValue = this.getUploadedRowValue(row, [
      "RD/LD #",
      "RD:LD Ratio",
      "RD LD Ratio",
    ]);
    toggleSingle(
      this.nonDaMultipleAddonOptionsByAddonName(index, "RD:LD Ratio"),
      rdldValue,
      this.getRdldRatioBoolKey
    );

    const cftfValue = this.getUploadedRowValue(row, [
      "TF/CF #",
      "CF:TF Ratio",
      "TF CF Ratio",
    ]);
    toggleSingle(
      this.nonDaMultipleAddonOptionsByAddonName(index, "CF:TF Ratio"),
      cftfValue,
      this.getCftfRatioBoolKey
    );

    const pureNicheValue = this.getUploadedRowValue(row, ["Pure Niche"]);
    if (
      this.isTruthyUploadValue(pureNicheValue) &&
      !this.isPureNicheDisabledForCountry(link)
    ) {
      // Upload: Pure Niche wins — clear Minimum Traffic first so niche can enable.
      // Stable Traffic Graph is independent and left untouched.
      if (this.hasSelectedTrafficAddon(link)) {
        this.onTrafficSelect(index, "null");
      }
      this.setNichePurity(index, true);
    } else if (this.isFalsyUploadValue(pureNicheValue)) {
      this.setNichePurity(index, false);
    }

    this.enforceCountryAddonRestrictions(index);
    this.enforceNicheTrafficMutualExclusion(index);
    this.enforceRatioAddonMutualExclusion(index);
    this.refreshAddonCosts(index);
    this.updateLinkTotal(index);
  },
  async handleUploadedFile(convertedData) {
    this.loaderText = "";
    this.loaded = true;

    // Yield a tick so loader renders before processing rows.
    await this.$nextTick();
    await new Promise((resolve) => setTimeout(resolve, 0));

    const rows = convertedData?.body || [];
    try {
      rows.forEach((row) => {
        const daName = row["DOMAIN AUTHORITY"];
        if (daName === undefined || daName === null || String(daName).trim() === "") {
          return;
        }

        let index = this.links.length - 1;
        const last = this.links[index];
        if (!last || last.product) {
          this.addLink("clickBtn");
          index = this.links.length - 1;
        }

        const product = this.findProductByName(daName);
        if (!product) return;

        const link = this.links[index];
        link.metric = String(product.name || "").toUpperCase().startsWith("DR")
          ? "DR"
          : "DA";
        link.product = product;
        this.categories[index] = this.getPrimaryCategories(product);

        const categoryName = row["PRIMARY CATEGORY"];
        if (categoryName !== undefined && categoryName !== null && String(categoryName).trim() !== "") {
          const category = this.findCategoryByName(index, categoryName);
          if (category) {
            link.primary_category = category;
            this.addon_da_options[index] = this.getAddonDaOption(index);
          }
        }

        const secondaryCategory =
          row["SECONDARY CATEGORY"] ??
          row["SECONDARY_CATEGORY"] ??
          row["SECONDARYCATEGORY"] ??
          "";

        link.secondry_category = secondaryCategory || "";
        link.text = row["ANCHOR TEXT"] || "";
        link.url = row["DESTINATION URL"] || "https://";

        this.applyUploadedAddonsFromRow(row, index);
        this.updateLinkTotal(index);
      });
    } finally {
      this.loaderText = "";
      this.loaded = false;
      if (rows.length && this.links.length) {
        this.maxRenderedLinks = Math.min(50, this.links.length);
      }
    }
  },
  getPrimaryCategories(product) {
    const cats = (product?.categories || []).filter((cat) => !isBrandCategory(cat));
    return cats.map((cat) => ({
      id: cat.id,
      name: cat.name,
      cost: cat?.pivot?.cost ?? 0,
      special: cat.special,
      relevant_category_lists: cat.relevant_category_lists || [],
    }));
  },
},
};
</script>

<style scoped>
.form-group.checkbox.addon-disabled {
  opacity: 1;
}

.form-group.checkbox.addon-disabled label,
.form-group.checkbox.addon-disabled label span {
  color: #9ca3af !important;
  cursor: not-allowed !important;
}

.form-group.checkbox.addon-disabled input[type="checkbox"] {
  cursor: not-allowed !important;
  opacity: 0.5;
}

.form-group.checkbox.addon-disabled .addon-price {
  color: #9ca3af !important;
  cursor: not-allowed !important;
}

.select-with-price.addon-select-disabled {
  cursor: not-allowed !important;
}

.select-with-price.addon-select-disabled .form-control,
.select-with-price.addon-select-disabled .form-select,
.form-control.addon-select-control-disabled,
.form-select.addon-select-control-disabled,
.form-control.addon-select-control-disabled:disabled,
.form-select.addon-select-control-disabled:disabled {
  background: #f3f4f6 !important;
  color: #9ca3af !important;
  border-color: #d1d5db !important;
  box-shadow: none !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
}

.select-with-price.addon-select-disabled ::v-deep .form-control,
.select-with-price.addon-select-disabled ::v-deep .form-select,
.select-with-price.addon-select-disabled ::v-deep select {
  background: #f3f4f6 !important;
  color: #9ca3af !important;
  border-color: #d1d5db !important;
  box-shadow: none !important;
  opacity: 1 !important;
  cursor: not-allowed !important;
  pointer-events: none;
}

.select-with-price.addon-select-disabled .price-tag {
  color: #9ca3af !important;
  cursor: not-allowed !important;
}

.metric-option-disabled {
  opacity: 1;
  background: #f3f4f6 !important;
  color: #9ca3af !important;
  border-color: #d1d5db !important;
  cursor: not-allowed;
  pointer-events: none;
}

.toggle-option-disabled {
  background: #f3f4f6 !important;
  color: #9ca3af !important;
  border-color: #d1d5db !important;
  cursor: not-allowed !important;
}

.toggle-option.toggle-option-disabled.active {
  background: #d1d5db !important;
  color: #6b7280 !important;
  border-color: #d1d5db !important;
  opacity: 1;
  box-shadow: none !important;
  cursor: not-allowed !important;
}

.niche-purity-section-box.addon-select-disabled {
  background-color: #f9fafb !important;
  border-color: #d1d5db !important;
  box-shadow: none !important;
  cursor: not-allowed !important;
}

.niche-purity-section-box.addon-select-disabled .niche-purity-label,
.niche-purity-section-box.addon-select-disabled .addon-price {
  color: #9ca3af !important;
  cursor: not-allowed !important;
}

.niche-purity-section-box.addon-select-disabled .toggle-box,
.toggle-box.addon-select-disabled {
  background: #f3f4f6 !important;
  border-color: #d1d5db !important;
  cursor: not-allowed !important;
}

.locked-field,
.locked-field:disabled {
  background: #f3f4f6 !important;
  color: #6b7280 !important;
  border-color: #d1d5db !important;
}

.addon-conflict-tip-wrap {
  position: relative;
}

.addon-conflict-tip {
  display: none;
  position: absolute;
  left: 50%;
  bottom: calc(100% + 6px);
  transform: translateX(-50%);
  z-index: 30;
  width: max-content;
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  background-color: #000 !important;
  color: #fff !important;
  opacity: 1 !important;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  pointer-events: none;
  box-shadow: none;
}

.addon-conflict-tip::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px 5px 0 5px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
  opacity: 1;
}

.addon-conflict-tip-wrap:hover > .addon-conflict-tip {
  display: block;
}
</style>
